<template>
  <div style="display: inline-block;">
    <span @click="show()">
      <slot></slot>
    </span>
    <el-dialog v-if="dialogFormVisible" class="el-dialog-lg" :close-on-click-modal="false" @close="updateStore"
      :modal="!mobiletype && !trackTask" :visible.sync="dialogFormVisible" width="100%" :fullscreen="!mobiletype">
      <div class="hearderLogo" v-if="!mobiletype && !trackTask">
        <HeaderSimple></HeaderSimple>
      </div>
      <div class="trackBody">
        <h3 class="text-center trackTitle">包裹申报</h3>
        <el-form :model="form" ref="form" :rules="rules" label-width="120px">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="转运公司" prop="transport_company_id">
                <el-select v-model="form.transport_company_id" @change="changeTransportCompany">
                  <el-option v-for="item in transport_company_list" :key="item.express_company_id"
                    :label="item.express_company_name" :value="item.express_company_id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="转运账号" prop="transport_account_id">
                <el-select v-model="form.transport_account_id" @change="getInfo">
                  <el-option v-for="item in transport_account_list" :key="item.zhuanyun_account_id"
                    :label="item.zhuanyun_account_name" :value="item.zhuanyun_account_id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <template v-if="isGetFormData">
            <div style="text-align:center">
              <Loading></Loading>
            </div>
          </template>
          <template v-else>
            <template v-if="express_company_code == 'uszcn'">
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="转运仓库" prop="warehouse_id">
                    <el-select v-model="form.warehouse_id" @change="warehouse_change">
                      <el-option v-for="item in warehouse_list" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="快递公司" prop="courier">
                    <el-select v-model="form.courier">
                      <el-option v-for="item in courier_list" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="转运线路" prop="shipping_route">
                    <el-select v-model="form.shipping_route">
                      <el-option v-for="item in shipping_route_list" :key="item.value" :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="包裹单号" prop="package_tracking_number">
                    <el-input v-model="form.package_tracking_number" style="width:205px;"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="申报类型" prop="declare_type">
                    <el-radio v-model="form.declare_type" label="1" @input="changeAddr">普通预报</el-radio>
                    <el-radio v-model="form.declare_type" label="2" @input="changeAddr">货到即发</el-radio>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="申报汇率" prop="rate">
                    <el-input v-model="form.rate" style="width:100px;"></el-input> CNY = 1 {{ declare_currency }}
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <div style="text-align: center;">商品列表</div>
                <ul class="error-messages" v-if="!isEmptyErrors" style="margin:10px;">
                  <li v-for="error in errors">{{ error[0].message }}</li>
                </ul>
                <el-table :data="form.product_list" border style="margin:20px auto;width:100%;">
                  <el-table-column label="商品信息" width="calc(100% - 580px)">
                    <template slot-scope="scope">
                      <div>
                        <div class="img-container">
                          <a :href='groupOrderLine[scope.$index].website.substr(0, 7).toLowerCase() == "https://" || groupOrderLine[scope.$index].website.substr(0, 8).toLowerCase() == "https://" ? groupOrderLine[scope.$index].website : "https://" + groupOrderLine[scope.$index].website'
                            target="_blank">
                            <img v-if="groupOrderLine[scope.$index].picture"
                              :src="groupOrderLine[scope.$index].picture" />
                            <img v-else src="https://pic.joyorders.com/blank.png" />
                            <span class="goodsNum"
                              v-if="groupOrderLine[scope.$index].number > 1">{{ groupOrderLine[scope.$index].number }}</span>
                          </a>
                        </div>
                        <div class="order-des">
                          <p class="name"><a
                              :href='groupOrderLine[scope.$index].website.substr(0, 7).toLowerCase() == "http://" || groupOrderLine[scope.$index].website.substr(0, 8).toLowerCase() == "https://" ? groupOrderLine[scope.$index].website : "http://" + groupOrderLine[scope.$index].website'
                              target="_blank">{{ groupOrderLine[scope.$index].name }}</a></p>
                          <div class="notMobile spec"
                            v-show="formatSpec(groupOrderLine[scope.$index].spec, groupOrderLine[scope.$index])">
                            <span v-show="!groupOrderLine[scope.$index].isHideSpecLabel">规格：</span>
                            <span v-html="formatSpec(groupOrderLine[scope.$index].spec,groupOrderLine[scope.$index])"></span>
                          </div>
                          <div style="height:24px;" v-show="!formatSpec(groupOrderLine[scope.$index].spec,groupOrderLine[scope.$index])">
                          </div>
                          <div class="notMobile spec" v-show="groupOrderLine[scope.$index].sku"
                            style="position:relative;display: flex;">
                            <!--<span>货号：</span>-->
                            <span>{{ groupOrderLine[scope.$index].sku }}</span>
                          </div>
                          <div v-if="groupOrderLine[scope.$index].discounted_price !== groupOrderLine[scope.$index].price"
                            class="notMobile" style="display: flex;align-items: center;">
                            <a
                              class="order-price">{{ (groupOrderLine[scope.$index].discounted_price) | currency(order.currency_symbol) }}</a>
                            <del class="order-price">
                              {{ (groupOrderLine[scope.$index].price) | currency(order.currency_symbol) }}</del>
                          </div>
                          <div v-if="groupOrderLine[scope.$index].discounted_price == groupOrderLine[scope.$index].price"
                            class="notMobile" style="display: flex;align-items: center;">
                            <p class="order-price">
                              {{ (groupOrderLine[scope.$index].price) | currency(order.currency_symbol) }}</p>
                          </div>

                        </div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="申报信息" width="580">
                    <template slot-scope="scope">
                      <div style="margin-bottom:10px;display:flex;align-items:center;">
                          <div class="declare_info_left">
                            品牌|品名
                          </div>
                          <div>
                            <el-input style="width:202px" v-model="scope.row.product_brand"></el-input>                   
                            <el-input v-model="scope.row.product_name" style="width:202px" @input="generateDesc"></el-input>
                          </div>
                      </div>
                      <div style="margin-bottom:10px;display:flex;align-items:center;">
                          <div class="declare_info_left">
                            申报类目
                          </div>
                          <div>
                              <el-cascader style="width:408px;" v-model="scope.row.product_category_id_list"
                              @visible-change="cascaderChange" :options="product_category_casader_list"></el-cascader>
                          </div>
                      </div>
                      <div style="margin-bottom:10px;display:flex;align-items:center;">
                          <div class="declare_info_left">
                            规格|数量
                          </div>
                          <div>
                            <el-input style="width:100px" v-model="scope.row.product_specifications"></el-input>
                            <el-input style="width:100px" class="num_input" :class="{ 'danger': original_product_list[scope.$index]['num_diff'] }"
                              v-model="scope.row.product_quantity" type="InputNumber"
                              @input="changeKeyField($event, 'num', scope, true)"></el-input>  
                          </div>
                      </div>
                      <div style="margin-bottom:10px;display:flex;align-items:center;">
                          <div class="declare_info_left">
                            申报单价
                          </div>
                          <div>
                            <el-input @input="changeKeyField($event, '', scope, true)" placeholder="申报价格" style="width:100px;" v-model="scope.row.declare_pre_product_price" type="InputNumber" :precision="2"
                              :step="0.1"></el-input>
                          </div>
                          <div style="margin:0 10px;">
                            申报总价
                          </div>
                          <div>
                            <el-input placeholder="申报价格" style="width:100px;" v-model="scope.row.declare_product_price" type="InputNumber" :precision="2"
                              :step="0.1"></el-input>
                            {{ declare_currency }}
                          </div>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </el-row>
              <!--<el-row>
                <div style="text-align: center;">商品列表</div>
                <ul class="error-messages" v-if="!isEmptyErrors" style="margin:10px;">
                  <li v-for="error in errors">{{error[0].message}}</li>
                </ul>
                <el-table :data="form.product_list" border style="margin:20px auto;">
                  <el-table-column label="商品名称" width="130">
                    <template slot-scope="scope">
                      <el-input v-model="scope.row.product_name" style="width:100%" @input="generateDesc"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column label="商品分类" width="410">
                    <template slot-scope="scope">
                      <el-cascader style="width:100%;" v-model="scope.row.product_category_id_list" @visible-change="cascaderChange"
                      :options="product_category_casader_list"></el-cascader>
                    </template>
                  </el-table-column>
                  <el-table-column label="商品品牌" width="139">
                    <template slot-scope="scope">
                      <el-input v-model="scope.row.product_brand"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column label="商品型号" width="100">
                    <template slot-scope="scope">
                      <el-input v-model="scope.row.product_specifications"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column label="数量" width="70">
                    <template slot-scope="scope">
                      <el-input class="num_input" :class="{'danger':original_product_list[scope.$index]['num_diff']}" v-model="scope.row.product_quantity" type="InputNumber" @input="changeKeyField($event,'num',scope,true)"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column width="90">
                    <template slot="header" slot-scope="scope">
                      <p>价格<sub>{{product_currency}}</sub></p>
                    </template>
                    <template slot-scope="scope">
                      {{ scope.row.product_price }}
                    </template>
                  </el-table-column>
                  <el-table-column width="120">
                    <template slot="header" slot-scope="scope">
                      <p>申报价格<sub>{{declare_currency}}</sub></p>
                    </template>
                    <template slot-scope="scope">
                      <div>
                        <el-input v-model="scope.row.declare_product_price" type="InputNumber" :precision="2" :step="0.1"></el-input>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </el-row>-->
              <el-row :gutter="20">
                <el-col :span="24">
                  <el-form-item label="收货地址" prop="address_id">
                    <el-select
                      :class="{ 'not_matched': form.address_id && address_list.find(i => i.value == form.address_id).match_index < 4 }"
                      placeholder="请选择地址" v-model="form.address_id" style="width:100%;" :disabled="form.declare_type == 1">
                      <el-option v-for="item in address_list" class="aligh-left-select" :key="item.value"
                        :label="item.displayLabel" :value="item.value"
                        :disabled="item.account_id != form.transport_account_id">
                      </el-option>
                    </el-select>
                    <!--<el-select style="width:100%;height:50px;"
                        v-model="form.address_id"
                        clearable
                        filterable
                        :filter-method="remotetransportSearch"
                        class="input-width customheight_auto"
                        placeholder="请选择地址">
                        <el-option
                          v-for="item in remoteAddress"
                          :key="item.value"
                          :label="item.displayLabel"
                          :value="item.value"></el-option>
              </el-select>-->
                  </el-form-item>
                </el-col>
                <el-col v-if="form.address_id && address_list.find(i => i.value == form.address_id).match_index < 4" :span="24">
                  <el-form-item label="正确地址">
                    <span v-if="address_list.find(i => i.value == form.address_id).match_index == 1">{{ order.address.mobile
                    }}</span>
                    {{ `${order.address.province + order.address.city + order.address.county} ${order.address.address1}` }}
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="24">
                  <el-form-item label="">
                    <div class="display:flex;">
                      <el-checkbox class="option-checkbox" label="货物清点" true-label="yes" false-label="no"
                        v-model="form.items_counting"></el-checkbox>
                      <el-checkbox class="option-checkbox" label="货物拍照" true-label="yes" false-label="no"
                        v-model="form.package_content_photos"></el-checkbox>
                      <el-checkbox class="option-checkbox" label="取出发票" true-label="yes" false-label="no"
                        v-model="form.invoice_removal"></el-checkbox>
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="24">
                  <el-form-item label="包裹描述" prop="package_description">
                    <el-input type="textarea" v-model="form.package_description"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </template>
            <template v-if="express_company_code == 'ewe_us'">
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="转运仓库" prop="warehouseId">
                    <el-select v-model="formEWE.warehouseId">
                      <el-option v-for="item in warehouse_list" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="快递运单号" prop="carrierNo">
                    <el-input v-model="formEWE.carrierNo" style="width:205px;"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="申报类型" prop="type">
                    <el-radio v-model="formEWE.type" label="1" @input="changeAddrEWE">普通预报</el-radio>
                    <el-radio v-model="formEWE.type" label="2" @input="changeAddrEWE">货到即发</el-radio>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="申报汇率" prop="rate">
                    <el-input v-model="form.rate" style="width:100px;"></el-input> CNY = 1 {{ declare_currency }}
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row v-if="formEWE.type==2" :gutter="20">
                <el-col :span="12">
                  <el-form-item label="发货线路" prop="orderType">
                    <el-select v-model="formEWE.orderType">
                      <el-option v-for="item in channels" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <div style="text-align: center;">商品列表</div>
                <ul class="error-messages" v-if="!isEmptyErrors" style="margin:10px;">
                  <li v-for="error in errors">{{ error[0].message }}</li>
                </ul>
                <el-table :data="formEWE.goodsList" border style="margin:20px auto;width:100%;">
                  <el-table-column label="商品信息" width="calc(100% - 580px)">
                    <template slot-scope="scope">
                      <div>
                        <div class="img-container">
                          <a :href='groupOrderLine[scope.$index].website.substr(0, 7).toLowerCase() == "https://" || groupOrderLine[scope.$index].website.substr(0, 8).toLowerCase() == "https://" ? groupOrderLine[scope.$index].website : "https://" + groupOrderLine[scope.$index].website'
                            target="_blank">
                            <img v-if="groupOrderLine[scope.$index].picture"
                              :src="groupOrderLine[scope.$index].picture" />
                            <img v-else src="https://pic.joyorders.com/blank.png" />
                            <span class="goodsNum"
                              v-if="groupOrderLine[scope.$index].number > 1">{{ groupOrderLine[scope.$index].number }}</span>
                          </a>
                        </div>
                        <div class="order-des">
                          <p class="name"><a
                              :href='groupOrderLine[scope.$index].website.substr(0, 7).toLowerCase() == "http://" || groupOrderLine[scope.$index].website.substr(0, 8).toLowerCase() == "https://" ? groupOrderLine[scope.$index].website : "http://" + groupOrderLine[scope.$index].website'
                              target="_blank">{{ groupOrderLine[scope.$index].name }}</a></p>
                          <div class="notMobile spec"
                            v-show="formatSpec(groupOrderLine[scope.$index].spec, groupOrderLine[scope.$index])">
                            <span v-show="!groupOrderLine[scope.$index].isHideSpecLabel">规格：</span>
                            <span v-html="formatSpec(groupOrderLine[scope.$index].spec,groupOrderLine[scope.$index])"></span>
                          </div>
                          <div style="height:24px;" v-show="!formatSpec(groupOrderLine[scope.$index].spec,groupOrderLine[scope.$index])">
                          </div>
                          <div class="notMobile spec" v-show="groupOrderLine[scope.$index].sku"
                            style="position:relative;display: flex;">
                            <!--<span>货号：</span>-->
                            <span>{{ groupOrderLine[scope.$index].sku }}</span>
                          </div>
                          <div v-if="groupOrderLine[scope.$index].discounted_price !== groupOrderLine[scope.$index].price"
                            class="notMobile" style="display: flex;align-items: center;">
                            <a
                              class="order-price">{{ (groupOrderLine[scope.$index].discounted_price) | currency(order.currency_symbol) }}</a>
                            <del class="order-price">
                              {{ (groupOrderLine[scope.$index].price) | currency(order.currency_symbol) }}</del>
                          </div>
                          <div v-if="groupOrderLine[scope.$index].discounted_price == groupOrderLine[scope.$index].price"
                            class="notMobile" style="display: flex;align-items: center;">
                            <p class="order-price">
                              {{ (groupOrderLine[scope.$index].price) | currency(order.currency_symbol) }}</p>
                          </div>

                        </div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="申报信息" width="580">
                    <template slot-scope="scope">
                      <div style="margin-bottom:10px;display:flex;align-items:center;">
                          <div class="declare_info_left">
                            品牌
                          </div>
                          <div>
                            <el-input style="width:202px" v-model="scope.row.brand"></el-input>                   
                          </div>
                      </div>
                      <div style="margin-bottom:10px;display:flex;align-items:center;">
                          <div class="declare_info_left">
                            申报类目
                          </div>
                          <div>
                              <el-cascader style="width:408px;" v-model="scope.row.goodsType_list"
                               :options="product_category_casader_list"></el-cascader>
                          </div>
                      </div>
                      <div style="margin-bottom:10px;display:flex;align-items:center;">
                          <div class="declare_info_left">
                            规格|数量
                          </div>
                          <div>
                            <el-input style="width:100px" v-model="scope.row.goodsModel"></el-input>
                            <el-input style="width:100px" class="num_input" :class="{ 'danger': original_product_list[scope.$index]['num_diff'] }"
                              v-model="scope.row.quantity" type="InputNumber" @input="changeKeyField($event, 'num', scope, true)"
                              ></el-input>  
                          </div>
                      </div>
                      <div style="margin-bottom:10px;display:flex;align-items:center;">
                          <div class="declare_info_left">
                            申报单价
                          </div>
                          <div>
                            <el-input @input="changeKeyField($event, '', scope, true)" placeholder="申报价格" style="width:100px;" v-model="scope.row.declare_pre_product_price" type="InputNumber" :precision="2"
                              :step="0.1"></el-input>
                          </div>
                          <div style="margin:0 10px">
                            申报总价
                          </div>
                          <div>
                            <el-input :disabled="true" placeholder="申报价格" style="width:100px;" v-model="scope.row.declare_product_price" type="InputNumber" :precision="2"
                              :step="0.1"></el-input>
                            {{ declare_currency }}
                          </div>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </el-row>

              <el-row v-if="formEWE.type==2" :gutter="20">
                <el-col :span="24">
                  <el-form-item label="收货地址" prop="customerAddressId">
                    <el-select
                      :class="{ 'not_matched': formEWE.customerAddressId && address_list.find(i => i.value == formEWE.address_id).match_index < 4 }"
                      placeholder="请选择地址" v-model="formEWE.customerAddressId" style="width:100%;" :disabled="formEWE.type == 1">
                      <el-option v-for="item in address_list" class="aligh-left-select" :key="item.value"
                        :label="item.displayLabel" :value="item.value"
                        :disabled="item.account_id != form.transport_account_id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row v-if="vas_id_list.length && formEWE.type==2" :gutter="20">
                <el-col :span="24">
                  <el-form-item label="增值服务">
                    <el-checkbox-group v-model="formEWE.valueAddedList">
                      <el-checkbox v-for="(item,index) in vas_id_list" :key="index" class="option-checkbox" :label="item.value">
                        {{ item.label }}
                      </el-checkbox>
                    </el-checkbox-group>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row v-if="formEWE.type==2" :gutter="20">
                <el-col :span="24">
                  <el-form-item label="包裹描述" prop="nickname">
                    <el-input type="textarea" v-model="formEWE.nickname"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </template>
            <template v-if="express_company_code == 'cpszy'">
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="转运仓库" prop="stock_id">
                    <el-select v-model="formCPS.stock_id" @change="warehouse_change_cps">
                      <el-option v-for="item in warehouse_list" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="快递公司" prop="express">
                    <el-select v-model="formCPS.express">
                      <el-option v-for="item in courier_list" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="渠道" prop="channel_id">
                    <el-select v-model="formCPS.channel_id">
                      <el-option v-for="item in shipping_route_list" :key="item.value" :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="包裹单号" prop="sn">
                    <el-input v-model="formCPS.sn" style="width:205px;"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="申报类型" prop="declare_type">
                    <el-radio v-model="formCPS.type" label="1" @input="changeAddrCPS">普通预报</el-radio>
                    <el-radio v-model="formCPS.type" label="2" @input="changeAddrCPS">货到即发</el-radio>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="申报汇率" prop="rate">
                    <el-input v-model="formCPS.rate" style="width:100px;"></el-input> USD = 1 {{ declare_currency }}
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <div style="text-align: center;">商品列表</div>
                <ul class="error-messages" v-if="!isEmptyErrors" style="margin:10px;">
                  <li v-for="error in errors">{{ error[0].message }}</li>
                </ul>
                <el-table :data="formCPS.goods" border style="margin:20px auto;width:100%;">
                  <el-table-column label="商品信息" width="calc(100% - 580px)">
                    <template slot-scope="scope">
                      <div>
                        <div class="img-container">
                          <a :href='groupOrderLine[scope.$index].website.substr(0, 7).toLowerCase() == "https://" || groupOrderLine[scope.$index].website.substr(0, 8).toLowerCase() == "https://" ? groupOrderLine[scope.$index].website : "https://" + groupOrderLine[scope.$index].website'
                            target="_blank">
                            <img v-if="groupOrderLine[scope.$index].picture"
                              :src="groupOrderLine[scope.$index].picture" />
                            <img v-else src="https://pic.joyorders.com/blank.png" />
                            <span class="goodsNum"
                              v-if="groupOrderLine[scope.$index].number > 1">{{ groupOrderLine[scope.$index].number }}</span>
                          </a>
                        </div>
                        <div class="order-des">
                          <p class="name"><a
                              :href='groupOrderLine[scope.$index].website.substr(0, 7).toLowerCase() == "http://" || groupOrderLine[scope.$index].website.substr(0, 8).toLowerCase() == "https://" ? groupOrderLine[scope.$index].website : "http://" + groupOrderLine[scope.$index].website'
                              target="_blank">{{ groupOrderLine[scope.$index].name }}</a></p>
                          <div class="notMobile spec"
                            v-show="formatSpec(groupOrderLine[scope.$index].spec, groupOrderLine[scope.$index])">
                            <span v-show="!groupOrderLine[scope.$index].isHideSpecLabel">规格：</span>
                            <span v-html="formatSpec(groupOrderLine[scope.$index].spec,groupOrderLine[scope.$index])"></span>
                          </div>
                          <div style="height:24px;" v-show="!formatSpec(groupOrderLine[scope.$index].spec,groupOrderLine[scope.$index])">
                          </div>
                          <div class="notMobile spec" v-show="groupOrderLine[scope.$index].sku"
                            style="position:relative;display: flex;">
                            <!--<span>货号：</span>-->
                            <span>{{ groupOrderLine[scope.$index].sku }}</span>
                          </div>
                          <div v-if="groupOrderLine[scope.$index].discounted_price !== groupOrderLine[scope.$index].price"
                            class="notMobile" style="display: flex;align-items: center;">
                            <a
                              class="order-price">{{ (groupOrderLine[scope.$index].discounted_price) | currency(order.currency_symbol) }}</a>
                            <del class="order-price">
                              {{ (groupOrderLine[scope.$index].price) | currency(order.currency_symbol) }}</del>
                          </div>
                          <div v-if="groupOrderLine[scope.$index].discounted_price == groupOrderLine[scope.$index].price"
                            class="notMobile" style="display: flex;align-items: center;">
                            <p class="order-price">
                              {{ (groupOrderLine[scope.$index].price) | currency(order.currency_symbol) }}</p>
                          </div>

                        </div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="申报信息" width="580">
                    <template slot-scope="scope">
                      <div style="margin-bottom:10px;display:flex;align-items:center;">
                          <div class="declare_info_left">
                            品牌|品名
                          </div>
                          <div>
                            <el-input style="width:202px" v-model="scope.row.brand"></el-input>                   
                            <el-input v-model="scope.row.title" style="width:202px" @input="generateDesc"></el-input>
                          </div>
                      </div>
                      <div style="margin-bottom:10px;display:flex;align-items:center;">
                          <div class="declare_info_left">
                            申报类目
                          </div>
                          <div>
                              <el-cascader style="width:408px;" v-model="scope.row.category"
                              @visible-change="cascaderChange" :options="product_category_casader_list"></el-cascader>
                          </div>
                      </div>
                      <div style="margin-bottom:10px;display:flex;align-items:center;">
                          <div class="declare_info_left">
                            规格|数量
                          </div>
                          <div>
                            <el-input style="width:100px" v-model="scope.row.size"></el-input>
                            <el-input style="width:100px" class="num_input" :class="{ 'danger': original_product_list[scope.$index]['num_diff'] }"
                              v-model="scope.row.qty" type="InputNumber"
                              @input="changeKeyField($event, 'num', scope, true)"></el-input>  
                          </div>
                      </div>
                      <div style="margin-bottom:10px;display:flex;align-items:center;">
                          <div class="declare_info_left">
                            申报单价
                          </div>
                          <div>
                            <el-input @input="changeKeyField($event, '', scope, true)" placeholder="申报价格" style="width:100px;" v-model="scope.row.declare_pre_product_price" type="InputNumber" :precision="2"
                              :step="0.1"></el-input>
                          </div>
                          <div style="margin:0 10px;">
                            申报总价
                          </div>
                          <div>
                            <el-input :disabled="true" placeholder="申报价格" style="width:100px;" v-model="scope.row.declare_product_price" type="InputNumber" :precision="2"
                              :step="0.1"></el-input>
                            USD
                          </div>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="24">
                  <el-form-item label="收货地址" prop="address_id">
                    <el-select v-if="formCPS.address_list && formCPS.address_list.length"
                      :class="{ 'not_matched': formCPS.address_id && address_list.find(i => i.value == formCPS.address_id).match_index < 4 }"
                      placeholder="请选择地址" v-model="formCPS.address_id" style="width:100%;" :disabled="formCPS.type == 1">
                      <el-option v-for="item in address_list" class="aligh-left-select" :key="item.value"
                        :label="item.displayLabel" :value="item.value"
                        :disabled="item.account_id != formCPS.transport_account_id">
                      </el-option>
                    </el-select>
                    <div v-else>
                      <el-input :disabled="true" v-model="formCPS.fullAddress"></el-input>
                      <div style="display:none;">
                        <el-input v-model="formCPS.name"></el-input>
                        <el-input v-model="formCPS.tel"></el-input>
                        <el-input v-model="formCPS.country"></el-input>
                        <el-input v-model="formCPS.province"></el-input>
                        <el-input v-model="formCPS.city"></el-input>
                        <el-input v-model="formCPS.address"></el-input>
                      </div>
                    </div>
                  </el-form-item>
                </el-col>
                <el-col v-if="formCPS.address_id && address_list.find(i => i.value == formCPS.address_id).match_index < 4" :span="24">
                  <el-form-item label="正确地址">
                    <span v-if="address_list.find(i => i.value == formCPS.address_id).match_index == 1">{{ order.address.mobile
                    }}</span>
                    {{ `${order.address.province + order.address.city + order.address.county} ${order.address.address1}` }}
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row v-if="vas_id_list.length" :gutter="20">
                <el-col :span="24">
                  <el-form-item label="增值服务">
                    <el-checkbox-group v-model="formCPS.vas_id_list">
                      <el-checkbox v-for="(item,index) in vas_id_list" :key="index" class="option-checkbox" :label="item.value">
                        {{ item.label }}
                      </el-checkbox>
                    </el-checkbox-group>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="24">
                  <el-form-item label="包裹描述" prop="package_description">
                    <el-input type="textarea" v-model="formCPS.package_description"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </template>
            <template v-if="express_company_code == 'dingfengzy'">
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="转运线路" prop="linecode">
                    <el-select v-model="formDF.linecode">
                      <el-option v-for="item in shipping_route_list" :key="item.value" :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="快递公司" prop="courier">
                    <el-select v-model="formDF.parcelExpress">
                      <el-option v-for="item in courier_list" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="申报类型" prop="type">
                    <el-radio v-model="formDF.type" label="1" @input="changeAddrDF">普通预报</el-radio>
                    <el-radio v-model="formDF.type" label="2" @input="changeAddrDF">货到即发</el-radio>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="包裹单号" prop="expressNo">
                    <el-input v-model="formDF.expressNo" style="width:205px;"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <div style="text-align: center;">商品列表</div>
                <ul class="error-messages" v-if="!isEmptyErrors" style="margin:10px;">
                  <li v-for="error in errors">{{ error[0].message }}</li>
                </ul>
                <el-table :data="formDF.detailList" border style="margin:20px auto;width:100%;">
                  <el-table-column label="商品信息" width="calc(100% - 580px)">
                    <template slot-scope="scope">
                      <div>
                        <div class="img-container">
                          <a :href='groupOrderLine[scope.$index].website.substr(0, 7).toLowerCase() == "https://" || groupOrderLine[scope.$index].website.substr(0, 8).toLowerCase() == "https://" ? groupOrderLine[scope.$index].website : "https://" + groupOrderLine[scope.$index].website'
                            target="_blank">
                            <img v-if="groupOrderLine[scope.$index].picture"
                              :src="groupOrderLine[scope.$index].picture" />
                            <img v-else src="https://pic.joyorders.com/blank.png" />
                            <span class="goodsNum"
                              v-if="groupOrderLine[scope.$index].number > 1">{{ groupOrderLine[scope.$index].number }}</span>
                          </a>
                        </div>
                        <div class="order-des">
                          <p class="name"><a
                              :href='groupOrderLine[scope.$index].website.substr(0, 7).toLowerCase() == "http://" || groupOrderLine[scope.$index].website.substr(0, 8).toLowerCase() == "https://" ? groupOrderLine[scope.$index].website : "http://" + groupOrderLine[scope.$index].website'
                              target="_blank">{{ groupOrderLine[scope.$index].name }}</a></p>
                          <div class="notMobile spec"
                            v-show="formatSpec(groupOrderLine[scope.$index].spec, groupOrderLine[scope.$index])">
                            <span v-show="!groupOrderLine[scope.$index].isHideSpecLabel">规格：</span>
                            <span v-html="formatSpec(groupOrderLine[scope.$index].spec,groupOrderLine[scope.$index])"></span>
                          </div>
                          <div style="height:24px;" v-show="!formatSpec(groupOrderLine[scope.$index].spec,groupOrderLine[scope.$index])">
                          </div>
                          <div class="notMobile spec" v-show="groupOrderLine[scope.$index].sku"
                            style="position:relative;display: flex;">
                            <!--<span>货号：</span>-->
                            <span>{{ groupOrderLine[scope.$index].sku }}</span>
                          </div>
                          <div v-if="groupOrderLine[scope.$index].discounted_price !== groupOrderLine[scope.$index].price"
                            class="notMobile" style="display: flex;align-items: center;">
                            <a
                              class="order-price">{{ (groupOrderLine[scope.$index].discounted_price) | currency(order.currency_symbol) }}</a>
                            <del class="order-price">
                              {{ (groupOrderLine[scope.$index].price) | currency(order.currency_symbol) }}</del>
                          </div>
                          <div v-if="groupOrderLine[scope.$index].discounted_price == groupOrderLine[scope.$index].price"
                            class="notMobile" style="display: flex;align-items: center;">
                            <p class="order-price">
                              {{ (groupOrderLine[scope.$index].price) | currency(order.currency_symbol) }}</p>
                          </div>

                        </div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="申报信息" width="580">
                    <template slot-scope="scope">
                      <div style="margin-bottom:10px;display:flex;align-items:center;">
                          <div class="declare_info_left">
                            品牌|品名
                          </div>
                          <div>
                            <el-input style="width:202px" v-model="scope.row.brand"></el-input>                   
                            <el-input v-model="scope.row.goodsName" style="width:202px" @input="generateDesc"></el-input>
                          </div>
                      </div>
                      <div style="margin-bottom:10px;display:flex;align-items:center;">
                          <div class="declare_info_left">
                            申报类目
                          </div>
                          <div>
                              <el-cascader style="width:408px;" v-model="scope.row.goodsType_list"
                              @visible-change="cascaderChange" :options="product_category_casader_list"></el-cascader>
                          </div>
                      </div>
                      <div style="margin-bottom:10px;display:flex;align-items:center;">
                          <div class="declare_info_left">
                            规格|数量
                          </div>
                          <div>
                            <el-input style="width:100px" v-model="scope.row.goodsModel"></el-input>
                            <el-input style="width:100px" class="num_input" :class="{ 'danger': original_product_list[scope.$index]['num_diff'] }"
                              v-model="scope.row.quantity" type="InputNumber"
                              @input="changeKeyField($event, 'num', scope, true)"></el-input>  
                          </div>
                      </div>
                      <div style="margin-bottom:10px;display:flex;align-items:center;">
                          <div class="declare_info_left">
                            申报单价
                          </div>
                          <div>
                            <el-input @input="changeKeyField($event, '', scope, true)" placeholder="申报价格" style="width:100px;" v-model="scope.row.declare_pre_product_price" type="InputNumber" :precision="2"
                              :step="0.1"></el-input>
                          </div>
                          <div style="margin:0 10px;">
                            申报总价
                          </div>
                          <div>
                            <el-input placeholder="申报价格" style="width:100px;" v-model="scope.row.declare_product_price" type="InputNumber" :precision="2"
                              :step="0.1"></el-input>
                            {{ declare_currency }}
                          </div>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="24">
                  <el-form-item label="收货地址" prop="takeOverId">
                    <el-select
                      :class="{ 'not_matched': formDF.takeOverId && address_list.find(i => i.value == formDF.takeOverId).match_index < 4 }"
                      placeholder="请选择地址" v-model="formDF.takeOverId" style="width:100%;">
                      <el-option v-for="item in address_list" class="aligh-left-select" :key="item.value"
                        :label="item.displayLabel" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col v-if="formDF.takeOverId && address_list.find(i => i.value == formDF.takeOverId).match_index < 4" :span="24">
                  <el-form-item label="正确地址">
                    <span v-if="address_list.find(i => i.value == formDF.takeOverId).match_index == 1">{{ order.address.mobile
                    }}</span>
                    {{ `${order.address.province + order.address.city + order.address.county} ${order.address.address1}` }}
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="24">
                  <el-form-item label="增值服务">
                    <el-checkbox-group v-model="formDF.serviceList">
                      <el-checkbox v-for="(item,index) in vas_id_list" :key="index" class="option-checkbox" :label="item.value">
                        {{ item.label }}
                      </el-checkbox>
                    </el-checkbox-group>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="24">
                  <el-form-item label="包裹描述" prop="parcelDescribe">
                    <el-input type="textarea" v-model="formDF.parcelDescribe"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </template>
            <template v-if="express_company_code == 'bnsHK' || express_company_code == 'bnsMO'">
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="转运仓库" prop="warehouse_id">
                    <el-select v-model="formBNS.warehouse_id" @change="warehouse_change_bns">
                      <el-option v-for="item in warehouse_list" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="包裹单号" prop="package_tracking_number">
                    <el-input v-model="formBNS.package_tracking_number" style="width:205px;"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="申报汇率" prop="rate">
                    <el-input v-model="formBNS.rate" style="width:100px;"></el-input> CNY = 1 {{ declare_currency }}
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <div style="text-align: center;">商品列表</div>
                <ul class="error-messages" v-if="!isEmptyErrors" style="margin:10px;">
                  <li v-for="error in errors">{{ error[0].message }}</li>
                </ul>
                <el-table :data="formBNS.product_list" border style="margin:20px auto;width:100%;">
                  <el-table-column label="商品信息" width="calc(100% - 580px)">
                    <template slot-scope="scope">
                      <div>
                        <div class="img-container">
                          <a :href='groupOrderLine[scope.$index].website.substr(0, 7).toLowerCase() == "https://" || groupOrderLine[scope.$index].website.substr(0, 8).toLowerCase() == "https://" ? groupOrderLine[scope.$index].website : "https://" + groupOrderLine[scope.$index].website'
                            target="_blank">
                            <img v-if="groupOrderLine[scope.$index].picture"
                              :src="groupOrderLine[scope.$index].picture" />
                            <img v-else src="https://pic.joyorders.com/blank.png" />
                            <span class="goodsNum"
                              v-if="groupOrderLine[scope.$index].number > 1">{{ groupOrderLine[scope.$index].number }}</span>
                          </a>
                        </div>
                        <div class="order-des">
                          <p class="name"><a
                              :href='groupOrderLine[scope.$index].website.substr(0, 7).toLowerCase() == "http://" || groupOrderLine[scope.$index].website.substr(0, 8).toLowerCase() == "https://" ? groupOrderLine[scope.$index].website : "http://" + groupOrderLine[scope.$index].website'
                              target="_blank">{{ groupOrderLine[scope.$index].name }}</a></p>
                          <div class="notMobile spec"
                            v-show="formatSpec(groupOrderLine[scope.$index].spec, groupOrderLine[scope.$index])">
                            <span v-show="!groupOrderLine[scope.$index].isHideSpecLabel">规格：</span>
                            <span v-html="formatSpec(groupOrderLine[scope.$index].spec,groupOrderLine[scope.$index])"></span>
                          </div>
                          <div style="height:24px;" v-show="!formatSpec(groupOrderLine[scope.$index].spec,groupOrderLine[scope.$index])">
                          </div>
                          <div class="notMobile spec" v-show="groupOrderLine[scope.$index].sku"
                            style="position:relative;display: flex;">
                            <!--<span>货号：</span>-->
                            <span>{{ groupOrderLine[scope.$index].sku }}</span>
                          </div>
                          <div v-if="groupOrderLine[scope.$index].discounted_price !== groupOrderLine[scope.$index].price"
                            class="notMobile" style="display: flex;align-items: center;">
                            <a
                              class="order-price">{{ (groupOrderLine[scope.$index].discounted_price) | currency(order.currency_symbol) }}</a>
                            <del class="order-price">
                              {{ (groupOrderLine[scope.$index].price) | currency(order.currency_symbol) }}</del>
                          </div>
                          <div v-if="groupOrderLine[scope.$index].discounted_price == groupOrderLine[scope.$index].price"
                            class="notMobile" style="display: flex;align-items: center;">
                            <p class="order-price">
                              {{ (groupOrderLine[scope.$index].price) | currency(order.currency_symbol) }}</p>
                          </div>

                        </div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="申报信息" width="580">
                    <template slot-scope="scope">
                      <div style="margin-bottom:10px;display:flex;align-items:center;">
                          <div class="declare_info_left">
                            品名
                          </div>
                          <div>                   
                            <el-input v-model="scope.row.product_name" style="width:130px" @input="generateDesc"></el-input>
                          </div>
                      </div>
                      <div style="margin-bottom:10px;display:flex;align-items:center;">
                          <div class="declare_info_left">
                            申报类目
                          </div>
                          <div>
                              <el-cascader style="width:410px;" v-model="scope.row.product_category_id_list"
                              @visible-change="cascaderChange" :options="product_category_casader_list"></el-cascader>
                          </div>
                      </div>
                      <div style="margin-bottom:10px;display:flex;align-items:center;">
                          <div class="declare_info_left">
                            规格|数量
                          </div>
                          <div>
                            <el-input style="width:100px" v-model="scope.row.product_specifications"></el-input>
                            <el-input style="width:90px" class="num_input" :class="{ 'danger': original_product_list[scope.$index]['num_diff'] }"
                              v-model="scope.row.product_quantity" type="InputNumber"
                              @input="changeKeyField($event, 'num', scope, true)"></el-input>  
                          </div>
                      </div>
                      <div style="margin-bottom:10px;display:flex;align-items:center;">
                          <div class="declare_info_left">
                            申报单价
                          </div>
                          <div>
                            <el-input @input="changeKeyField($event, '', scope, true)" placeholder="申报价格" style="width:120px;" v-model="scope.row.declare_pre_product_price" type="InputNumber" :precision="2"
                              :step="0.1"></el-input>
                          </div>
                          <div style="margin:0 10px;">
                            申报总价
                          </div>
                          <div>
                            <el-input placeholder="申报价格" style="width:120px;" v-model="scope.row.declare_product_price" type="InputNumber" :precision="2"
                              :step="0.1"></el-input>
                            {{ declare_currency }}
                          </div>
                      </div>
                      <div style="margin-bottom:10px;display:flex;align-items:center;">
                        <div class="declare_info_left">
                          商品url
                        </div>
                        <div>
                          <el-input placeholder="商品url" style="width:410px;" v-model="scope.row.product_url"></el-input>
                        </div>
                    </div>
                    </template>
                  </el-table-column>
                </el-table>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="24">
                  <el-form-item label="">
                    <div class="display:flex;">
                      <el-checkbox class="option-checkbox" label="申报有赏" true-label="yes" false-label="no"
                        v-model="formBNS.share_for_reward"></el-checkbox>
                      <el-checkbox class="option-checkbox" label="包含液体" true-label="yes" false-label="no"
                        v-model="formBNS.liquid_contained"></el-checkbox>
                      <el-checkbox class="option-checkbox" label="包含电池" true-label="yes" false-label="no"
                        v-model="formBNS.battery_contained"></el-checkbox>
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
            </template>
            <template v-if="express_company_code == 'ibeede'">
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="转运仓库" prop="warehouse">
                    <el-select v-model="formbeede.warehouse" @change="warehouse_change_beede">
                      <el-option v-for="item in warehouse_list" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="发货线路" prop="channel">
                    <el-select v-model="formbeede.channel">
                      <el-option v-for="item in channels" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="申报类型" prop="shipment_method">
                    <el-radio v-model="formbeede.shipment_method" label="0" @input="generateDescbeede">普通预报</el-radio>
                    <el-radio v-model="formbeede.shipment_method" label="1" @input="generateDescbeede">货到即发</el-radio>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="物流单号" prop="AWB">
                    <el-input v-model="formbeede.AWB" style="width:205px;"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <div style="text-align: center;">商品列表</div>
                <ul class="error-messages" v-if="!isEmptyErrors" style="margin:10px;">
                  <li v-for="error in errors">{{ error[0].message }}</li>
                </ul>
                <el-table :data="formbeede.product_list" border style="margin:20px auto;width:100%;">
                  <el-table-column label="商品信息" width="calc(100% - 580px)">
                    <template slot-scope="scope">
                      <div>
                        <div class="img-container">
                          <a :href='groupOrderLine[scope.$index].website.substr(0, 7).toLowerCase() == "https://" || groupOrderLine[scope.$index].website.substr(0, 8).toLowerCase() == "https://" ? groupOrderLine[scope.$index].website : "https://" + groupOrderLine[scope.$index].website'
                            target="_blank">
                            <img v-if="groupOrderLine[scope.$index].picture"
                              :src="groupOrderLine[scope.$index].picture" />
                            <img v-else src="https://pic.joyorders.com/blank.png" />
                            <span class="goodsNum"
                              v-if="groupOrderLine[scope.$index].number > 1">{{ groupOrderLine[scope.$index].number }}</span>
                          </a>
                        </div>
                        <div class="order-des">
                          <p class="name"><a
                              :href='groupOrderLine[scope.$index].website.substr(0, 7).toLowerCase() == "http://" || groupOrderLine[scope.$index].website.substr(0, 8).toLowerCase() == "https://" ? groupOrderLine[scope.$index].website : "http://" + groupOrderLine[scope.$index].website'
                              target="_blank">{{ groupOrderLine[scope.$index].name }}</a></p>
                          <div class="notMobile spec"
                            v-show="formatSpec(groupOrderLine[scope.$index].spec, groupOrderLine[scope.$index])">
                            <span v-show="!groupOrderLine[scope.$index].isHideSpecLabel">规格：</span>
                            <span v-html="formatSpec(groupOrderLine[scope.$index].spec,groupOrderLine[scope.$index])"></span>
                          </div>
                          <div style="height:24px;" v-show="!formatSpec(groupOrderLine[scope.$index].spec,groupOrderLine[scope.$index])">
                          </div>
                          <div class="notMobile spec" v-show="groupOrderLine[scope.$index].sku"
                            style="position:relative;display: flex;">
                            <!--<span>货号：</span>-->
                            <span>{{ groupOrderLine[scope.$index].sku }}</span>
                          </div>
                          <div v-if="groupOrderLine[scope.$index].discounted_price !== groupOrderLine[scope.$index].price"
                            class="notMobile" style="display: flex;align-items: center;">
                            <a
                              class="order-price">{{ (groupOrderLine[scope.$index].discounted_price) | currency(order.currency_symbol) }}</a>
                            <del class="order-price">
                              {{ (groupOrderLine[scope.$index].price) | currency(order.currency_symbol) }}</del>
                          </div>
                          <div v-if="groupOrderLine[scope.$index].discounted_price == groupOrderLine[scope.$index].price"
                            class="notMobile" style="display: flex;align-items: center;">
                            <p class="order-price">
                              {{ (groupOrderLine[scope.$index].price) | currency(order.currency_symbol) }}</p>
                          </div>

                        </div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="申报信息" width="580">
                    <template slot-scope="scope">
                      <div style="margin-bottom:10px;display:flex;align-items:center;">
                          <div class="declare_info_left">
                            品牌|品名
                          </div>
                          <div>
                            <el-input style="width:202px" v-model="scope.row.product_brand"></el-input>                   
                            <el-input v-model="scope.row.product_name" style="width:202px" @input="generateDescbeede"></el-input>
                          </div>
                      </div>
                      <div style="margin-bottom:10px;display:flex;align-items:center;">
                          <div class="declare_info_left">
                            申报类目
                          </div>
                          <div>
                              <el-cascader style="width:408px;" v-model="scope.row.product_category_id_list"
                              @visible-change="cascaderChange" :options="product_category_casader_list"></el-cascader>
                          </div>
                      </div>
                      <div style="margin-bottom:10px;display:flex;align-items:center;">
                          <div class="declare_info_left">
                            规格|数量
                          </div>
                          <div>
                            <el-input style="width:100px" v-model="scope.row.product_specifications"></el-input>
                            <el-input style="width:100px" class="num_input" :class="{ 'danger': original_product_list[scope.$index]['num_diff'] }"
                              v-model="scope.row.product_quantity" type="InputNumber"
                              @input="changeKeyField($event, 'num', scope, true)"></el-input>  
                          </div>
                      </div>
                      <div style="margin-bottom:10px;display:flex;align-items:center;">
                          <div class="declare_info_left">
                            申报单价
                          </div>
                          <div>
                            <el-input  @input="changeKeyField($event, '', scope, true)" placeholder="申报价格" style="width:100px;" v-model="scope.row.declare_pre_product_price" type="InputNumber" :precision="2"
                              :step="0.1"></el-input>
                          </div>
                          <div style="margin:0 10px;">
                            申报总价
                          </div>
                          <div>
                            <el-input placeholder="申报价格" style="width:100px;" v-model="scope.row.declare_product_price" type="InputNumber" :precision="2"
                              :step="0.1"></el-input>
                            USD
                          </div>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="24">
                  <el-form-item label="收货地址" prop="address_id">
                    <el-select
                      :class="{ 'not_matched': formbeede.address_id && address_list.find(i => i.value == formbeede.address_id).match_index < 4 }"
                      placeholder="请选择地址" v-model="formbeede.address_id" style="width:100%;">
                      <el-option v-for="item in address_list" class="aligh-left-select" :key="item.value"
                        :label="item.displayLabel" :value="item.value"
                        :disabled="item.account_id != form.transport_account_id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col v-if="form.address_id && address_list.find(i => i.value == form.address_id).match_index < 4" :span="24">
                  <el-form-item label="正确地址">
                    <span v-if="address_list.find(i => i.value == form.address_id).match_index == 1">{{ order.address.mobile
                    }}</span>
                    {{ `${order.address.province + order.address.city + order.address.county} ${order.address.address1}` }}
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="24">
                  <el-form-item label="包裹描述" prop="package_description">
                    <el-input type="textarea" v-model="formbeede.package_description"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </template>
            <template v-if="express_company_code == 'zygjex'">
              <template v-if="formzygjex.type == 'normal'">
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="申报类型" prop="type">
                      <el-radio v-model="formzygjex.type" label="normal" @input="changeAddrzygjex">普通预报</el-radio>
                      <el-radio v-model="formzygjex.type" label="huodaojifa" @input="changeAddrzygjex">货到即发</el-radio>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="包裹单号" prop="package_description_01">
                      <el-input style="width:205px;" v-model="formzygjex.type1.package_tracking_number_01"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <div style="text-align: center;">商品列表</div>
                  <ul class="error-messages" v-if="!isEmptyErrors" style="margin:10px;">
                    <li v-for="error in errors">{{ error[0].message }}</li>
                  </ul>
                  <el-table :data="formzygjex.type2.l1_product_list" border style="margin:20px auto;width:100%;">
                    <el-table-column label="商品信息" width="calc(100% - 580px)">
                      <template slot-scope="scope">
                        <div>
                          <div class="img-container">
                            <a :href='groupOrderLine[scope.$index].website.substr(0, 7).toLowerCase() == "https://" || groupOrderLine[scope.$index].website.substr(0, 8).toLowerCase() == "https://" ? groupOrderLine[scope.$index].website : "https://" + groupOrderLine[scope.$index].website'
                              target="_blank">
                              <img v-if="groupOrderLine[scope.$index].picture"
                                :src="groupOrderLine[scope.$index].picture" />
                              <img v-else src="https://pic.joyorders.com/blank.png" />
                              <span class="goodsNum"
                                v-if="groupOrderLine[scope.$index].number > 1">{{ groupOrderLine[scope.$index].number }}</span>
                            </a>
                          </div>
                          <div class="order-des">
                            <p class="name"><a
                                :href='groupOrderLine[scope.$index].website.substr(0, 7).toLowerCase() == "http://" || groupOrderLine[scope.$index].website.substr(0, 8).toLowerCase() == "https://" ? groupOrderLine[scope.$index].website : "http://" + groupOrderLine[scope.$index].website'
                                target="_blank">{{ groupOrderLine[scope.$index].name }}</a></p>
                            <div class="notMobile spec"
                              v-show="formatSpec(groupOrderLine[scope.$index].spec, groupOrderLine[scope.$index])">
                              <span v-show="!groupOrderLine[scope.$index].isHideSpecLabel">规格：</span>
                              <span v-html="formatSpec(groupOrderLine[scope.$index].spec,groupOrderLine[scope.$index])"></span>
                            </div>
                            <div style="height:24px;" v-show="!formatSpec(groupOrderLine[scope.$index].spec,groupOrderLine[scope.$index])">
                            </div>
                            <div class="notMobile spec" v-show="groupOrderLine[scope.$index].sku"
                              style="position:relative;display: flex;">
                              <!--<span>货号：</span>-->
                              <span>{{ groupOrderLine[scope.$index].sku }}</span>
                            </div>
                            <div v-if="groupOrderLine[scope.$index].discounted_price !== groupOrderLine[scope.$index].price"
                              class="notMobile" style="display: flex;align-items: center;">
                              <a
                                class="order-price">{{ (groupOrderLine[scope.$index].discounted_price) | currency(order.currency_symbol) }}</a>
                              <del class="order-price">
                                {{ (groupOrderLine[scope.$index].price) | currency(order.currency_symbol) }}</del>
                            </div>
                            <div v-if="groupOrderLine[scope.$index].discounted_price == groupOrderLine[scope.$index].price"
                              class="notMobile" style="display: flex;align-items: center;">
                              <p class="order-price">
                                {{ (groupOrderLine[scope.$index].price) | currency(order.currency_symbol) }}</p>
                            </div>

                          </div>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column label="申报信息" width="580">
                      <template slot-scope="scope">
                        <div style="margin-bottom:10px;display:flex;align-items:center;">
                            <div class="declare_info_left">
                              品牌|品名
                            </div>
                            <div>
                              {{ scope.row.product_brand_name }}
                              <el-input v-model="scope.row.product_name_cn" style="width:100px"
                          @input="generateDesczygjex"></el-input>
                            </div>
                        </div>
                        <div style="margin-bottom:10px;display:flex;align-items:center;">
                            <div class="declare_info_left">
                              规格|数量
                            </div>
                            <div>
                              {{ scope.row.product_spec }},{{ scope.row.product_quantity }} 
                            </div>
                        </div>
                        <div style="margin-bottom:10px;display:flex;align-items:center;">
                            <div class="declare_info_left">
                              申报单价
                            </div>
                            <div>
                              {{ scope.row.declare_pre_product_price }}<label style="margin-left:5px;">CNY</label>
                            </div>
                            <div style="margin:0 10px;">
                              申报总价
                            </div>
                            <div>
                              {{ scope.row.declare_product_price }}<label style="margin-left:5px;">CNY</label>
                            </div>
                        </div>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-row>
                <!--<el-row>
                  <div style="text-align: center;">商品列表</div>
                  <ul class="error-messages" v-if="!isEmptyErrors" style="margin:10px;">
                    <li v-for="error in errors">{{ error[0].message }}</li>
                  </ul>
                  <el-table :data="formzygjex.type2.l1_product_list" border style="margin:20px auto;">
                    <el-table-column label="商品名称" width="330">
                      <template slot-scope="scope">
                        <el-input v-model="scope.row.product_name_cn" style="width:100%"
                          @input="generateDesczygjex"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column label="商品品牌" width="339">
                      <template slot-scope="scope">
                        {{ scope.row.product_brand_name }}
                      </template>
                    </el-table-column>
                    <el-table-column label="商品型号" width="110">
                      <template slot-scope="scope">
                        {{ scope.row.product_spec }}
                      </template>
                    </el-table-column>
                    <el-table-column label="数量" width="70">
                      <template slot-scope="scope">
                        {{ scope.row.product_quantity }}
                      </template>
                    </el-table-column>
                    <el-table-column width="90">
                      <template slot="header" slot-scope="scope">
                        <p>价格<sub>{{ product_currency }}</sub></p>
                      </template>
                      <template slot-scope="scope">
                        {{ scope.row.product_price }}
                      </template>
                    </el-table-column>
                    <el-table-column width="120">
                      <template slot="header" slot-scope="scope">
                        <p>申报价格<sub>CNY</sub></p>
                      </template>
                      <template slot-scope="scope">
                        {{ scope.row.declare_product_price }}
                      </template>
                    </el-table-column>
                  </el-table>
                </el-row>-->
                <el-row :gutter="20">
                  <el-col :span="24">
                    <el-form-item label="包裹描述" prop="l1_remark">
                      <el-input type="textarea" v-model="formzygjex.type1.product_name_01"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </template>
              <template v-else>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="发货线路" prop="l1_drop_down_list">
                      <el-select v-model="formzygjex.type2.l1_drop_down_list">
                        <el-option v-for="item in port_options" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="包裹单号" prop="tracking_no">
                      <el-input v-model="formzygjex.type2.tracking_no" style="width:205px;"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="申报类型" prop="type">
                      <el-radio v-model="formzygjex.type" label="normal" @input="changeAddrzygjex">普通预报</el-radio>
                      <el-radio v-model="formzygjex.type" label="huodaojifa" @input="changeAddrzygjex">货到即发</el-radio>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="申报汇率" prop="rate">
                      <el-input v-model="formzygjex.type2.rate" style="width:100px;"></el-input> CNY = 1 {{
                        declare_currency }}
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <div style="text-align: center;">商品列表</div>
                  <ul class="error-messages" v-if="!isEmptyErrors" style="margin:10px;">
                    <li v-for="error in errors">{{ error[0].message }}</li>
                  </ul>
                  <el-table :data="formzygjex.type2.l1_product_list" border style="margin:20px auto;width:100%;">
                    <el-table-column label="商品信息" width="calc(100% - 580px)">
                      <template slot-scope="scope">
                        <div>
                          <div class="img-container">
                            <a :href='groupOrderLine[scope.$index].website.substr(0, 7).toLowerCase() == "https://" || groupOrderLine[scope.$index].website.substr(0, 8).toLowerCase() == "https://" ? groupOrderLine[scope.$index].website : "https://" + groupOrderLine[scope.$index].website'
                              target="_blank">
                              <img v-if="groupOrderLine[scope.$index].picture"
                                :src="groupOrderLine[scope.$index].picture" />
                              <img v-else src="https://pic.joyorders.com/blank.png" />
                              <span class="goodsNum"
                                v-if="groupOrderLine[scope.$index].number > 1">{{ groupOrderLine[scope.$index].number }}</span>
                            </a>
                          </div>
                          <div class="order-des">
                            <p class="name"><a
                                :href='groupOrderLine[scope.$index].website.substr(0, 7).toLowerCase() == "http://" || groupOrderLine[scope.$index].website.substr(0, 8).toLowerCase() == "https://" ? groupOrderLine[scope.$index].website : "http://" + groupOrderLine[scope.$index].website'
                                target="_blank">{{ groupOrderLine[scope.$index].name }}</a></p>
                            <div class="notMobile spec"
                              v-show="formatSpec(groupOrderLine[scope.$index].spec, groupOrderLine[scope.$index])">
                              <span v-show="!groupOrderLine[scope.$index].isHideSpecLabel">规格：</span>
                              <span v-html="formatSpec(groupOrderLine[scope.$index].spec,groupOrderLine[scope.$index])"></span>
                            </div>
                            <div style="height:24px;" v-show="!formatSpec(groupOrderLine[scope.$index].spec,groupOrderLine[scope.$index])">
                            </div>
                            <div class="notMobile spec" v-show="groupOrderLine[scope.$index].sku"
                              style="position:relative;display: flex;">
                              <!--<span>货号：</span>-->
                              <span>{{ groupOrderLine[scope.$index].sku }}</span>
                            </div>
                            <div v-if="groupOrderLine[scope.$index].discounted_price !== groupOrderLine[scope.$index].price"
                              class="notMobile" style="display: flex;align-items: center;">
                              <a
                                class="order-price">{{ (groupOrderLine[scope.$index].discounted_price) | currency(order.currency_symbol) }}</a>
                              <del class="order-price">
                                {{ (groupOrderLine[scope.$index].price) | currency(order.currency_symbol) }}</del>
                            </div>
                            <div v-if="groupOrderLine[scope.$index].discounted_price == groupOrderLine[scope.$index].price"
                              class="notMobile" style="display: flex;align-items: center;">
                              <p class="order-price">
                                {{ (groupOrderLine[scope.$index].price) | currency(order.currency_symbol) }}</p>
                            </div>

                          </div>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column label="申报信息" width="580">
                      <template slot-scope="scope">
                        <div style="margin-bottom:10px;display:flex;align-items:center;">
                            <div class="declare_info_left">
                              品牌|品名
                            </div>
                            <div>
                              <el-input style="width:202px" v-model="scope.row.product_brand_name"></el-input>                 
                              <el-input v-model="scope.row.product_name_cn" style="width:202px"
                          @input="generateDesczygjex"></el-input>
                            </div>
                        </div>
                        <div style="margin-bottom:10px;display:flex;align-items:center;">
                            <div class="declare_info_left">
                              规格|数量
                            </div>
                            <div>
                              <el-input style="width:100px" v-model="scope.row.product_spec"></el-input>
                              <el-input style="width:100px" class="num_input" :class="{ 'danger': original_product_list[scope.$index]['num_diff'] }"
                                v-model="scope.row.product_quantity" type="InputNumber"
                                @input="changeKeyField($event, 'num', scope, true)"></el-input> 
                            </div>
                        </div>
                        <div style="margin-bottom:10px;display:flex;align-items:center;">
                            <div class="declare_info_left">
                              申报单价
                            </div>
                            <div>
                              <el-input @input="changeKeyField($event, '', scope, true)" style="width:100px" v-model="scope.row.declare_pre_product_price" type="InputNumber" :precision="2"
                            :step="0.1"></el-input><label style="margin-left:5px;">CNY</label>
                            </div>
                            <div style="margin:0 10px;">
                              申报总价
                            </div>
                            <div>
                              <el-input style="width:100px" v-model="scope.row.declare_product_price" type="InputNumber" :precision="2"
                            :step="0.1"></el-input><label style="margin-left:5px;">CNY</label>
                            </div>
                        </div>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-row>
                <!--<el-row>
                  <div style="text-align: center;">商品列表</div>
                  <ul class="error-messages" v-if="!isEmptyErrors" style="margin:10px;">
                    <li v-for="error in errors">{{ error[0].message }}</li>
                  </ul>
                  <el-table :data="formzygjex.type2.l1_product_list" border style="margin:20px auto;">
                    <el-table-column label="商品名称" width="330">
                      <template slot-scope="scope">
                        <el-input v-model="scope.row.product_name_cn" style="width:100%"
                          @input="generateDesczygjex"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column label="商品品牌" width="339">
                      <template slot-scope="scope">
                        <el-input v-model="scope.row.product_brand_name"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column label="商品型号" width="110">
                      <template slot-scope="scope">
                        <el-input v-model="scope.row.product_spec"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column label="数量" width="70">
                      <template slot-scope="scope">
                        <el-input class="num_input" :class="{ 'danger': original_product_list[scope.$index]['num_diff'] }"
                          v-model="scope.row.product_quantity" type="InputNumber"
                          @input="changeKeyField($event, 'num', scope, true)"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column width="90">
                      <template slot="header" slot-scope="scope">
                        <p>价格<sub>{{ product_currency }}</sub></p>
                      </template>
                      <template slot-scope="scope">
                        {{ scope.row.product_price }}
                      </template>
                    </el-table-column>
                    <el-table-column width="120">
                      <template slot="header" slot-scope="scope">
                        <p>申报价格<sub>CNY</sub></p>
                      </template>
                      <template slot-scope="scope">
                        <div>
                          <el-input v-model="scope.row.declare_product_price" type="InputNumber" :precision="2"
                            :step="0.1"></el-input>
                        </div>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-row>-->
                <el-row :gutter="20">
                  <el-col :span="24">
                    <el-form-item label="收货地址" prop="address_id">
                      <el-select placeholder="请选择地址" v-model="formzygjex.type2.l1_receiver" style="width:100%;">
                        <el-option v-for="item in address_list" class="aligh-left-select" :key="item.value"
                          :label="item.displayLabel" :value="item.value">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="保险保额(￥)" prop="l1_baoxian_price">
                      <el-input v-model="formzygjex.type2.l1_baoxian_price" type="InputNumber" :precision="2" :step="0.1"
                        style="width:100px;"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24">
                    <el-form-item label="">
                      <div style="display:flex;flex-wrap:wrap;">
                        <el-checkbox class="option-checkbox" label="危险品申报" true-label="是" false-label="否"
                          v-model="formzygjex.type2.l1_if_exist_dangerous_part"></el-checkbox>
                        <el-checkbox v-for="(item, index) in other_service_list" :key="index" class="option-checkbox"
                          :label="item.label" :true-label="item.value"
                          v-model="l1_other_service_list_total[index]"></el-checkbox>
                      </div>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="24">
                    <el-form-item label="包裹描述" prop="l1_remark">
                      <el-input type="textarea" v-model="formzygjex.type2.l1_remark"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </template>
            </template>
            <template v-if="express_company_code == 1542">
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="转运仓库" prop="warehouse_id">
                    <el-select v-model="form.warehouse_id" @change="warehouse_change">
                      <el-option v-for="item in warehouse_list" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="包裹单号" prop="package_tracking_number">
                    <el-input v-model="form.package_tracking_number" style="width:205px;"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <div style="text-align: center;">商品列表</div>
                <ul class="error-messages" v-if="!isEmptyErrors" style="margin:10px;">
                  <li v-for="error in errors">{{ error[0].message }}</li>
                </ul>
                <el-table :data="form.product_list" border style="margin:20px auto;">
                  <el-table-column label="商品名称" width="130">
                    <template slot-scope="scope">
                      <el-input v-model="scope.row.product_name" style="width:100%" @input="generateDesc"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column label="商品分类" width="410">
                    <template slot-scope="scope">
                      <el-cascader style="width:100%;" v-model="scope.row.product_category_id_list"
                        @visible-change="cascaderChange" :options="product_category_casader_list"></el-cascader>
                    </template>
                  </el-table-column>
                  <el-table-column label="商品品牌" width="139">
                    <template slot-scope="scope">
                      <el-input v-model="scope.row.product_brand"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column label="商品型号" width="100">
                    <template slot-scope="scope">
                      <el-input v-model="scope.row.product_specifications"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column label="数量" width="70">
                    <template slot-scope="scope">
                      <el-input v-model="scope.row.product_quantity" type="InputNumber" @input="generateDesc"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column width="90">
                    <template slot="header" slot-scope="scope">
                      <p>价格<sub>{{ product_currency }}</sub></p>
                    </template>
                    <template slot-scope="scope">
                      {{ scope.row.product_price }}
                    </template>
                  </el-table-column>
                  <el-table-column width="120">
                    <template slot="header" slot-scope="scope">
                      <p>申报价格<sub>{{ declare_currency }}</sub></p>
                    </template>
                    <template slot-scope="scope">
                      <div>
                        <el-input v-model="scope.row.declare_product_price" type="InputNumber" :precision="2"
                          :step="0.1"></el-input>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="">
                    <div style="display:flex;flex-wrap:wrap;">
                      <el-checkbox class="option-checkbox" label="申报有赏计划" true-label="yes" false-label="no"
                        v-model="temp2"></el-checkbox>
                      <el-checkbox class="option-checkbox" label="液体" true-label="yes" false-label="no"
                        v-model="temp2"></el-checkbox>
                      <el-checkbox class="option-checkbox" label="电池" true-label="yes" false-label="no"
                        v-model="temp2"></el-checkbox>
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
            </template>
            <template v-if="express_company_code == 'aozhuanyun'">
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="商家订单" prop="ws_ordernum">
                    <el-input v-model="form1548.ws_ordernum" style="width:205px;" @input="generateDesc1548"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="物流单号" prop="ws_transnum">
                    <el-input v-model="form1548.ws_transnum" style="width:205px;"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="转运线路" prop="port_id">
                    <el-select v-model="form1548.port_id">
                      <el-option v-for="item in port_options" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="申报类型" prop="auto_apply">
                    <el-radio v-model="form1548.auto_apply" label="0" @input="changeAddr1548">普通预报</el-radio>
                    <el-radio v-model="form1548.auto_apply" label="1" @input="changeAddr1548">货到即发</el-radio>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="24">
                  <el-form-item label="购物网站" prop="wz_url">
                    <el-input v-model="form1548.wz_url"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <div style="text-align: center;">商品列表</div>
                <ul class="error-messages" v-if="!isEmptyErrors" style="margin:10px;">
                  <li v-for="error in errors">{{ error[0].message }}</li>
                </ul>
                <el-table :data="form1548.goods" border style="margin:20px auto;width:100%;">
                  <el-table-column label="商品信息" width="calc(100% - 580px)">
                    <template slot-scope="scope">
                      <div>
                        <div class="img-container">
                          <a :href='groupOrderLine[scope.$index].website.substr(0, 7).toLowerCase() == "https://" || groupOrderLine[scope.$index].website.substr(0, 8).toLowerCase() == "https://" ? groupOrderLine[scope.$index].website : "https://" + groupOrderLine[scope.$index].website'
                            target="_blank">
                            <img v-if="groupOrderLine[scope.$index].picture"
                              :src="groupOrderLine[scope.$index].picture" />
                            <img v-else src="https://pic.joyorders.com/blank.png" />
                            <span class="goodsNum"
                              v-if="groupOrderLine[scope.$index].number > 1">{{ groupOrderLine[scope.$index].number }}</span>
                          </a>
                        </div>
                        <div class="order-des">
                          <p class="name"><a
                              :href='groupOrderLine[scope.$index].website.substr(0, 7).toLowerCase() == "http://" || groupOrderLine[scope.$index].website.substr(0, 8).toLowerCase() == "https://" ? groupOrderLine[scope.$index].website : "http://" + groupOrderLine[scope.$index].website'
                              target="_blank">{{ groupOrderLine[scope.$index].name }}</a></p>
                          <div class="notMobile spec"
                            v-show="formatSpec(groupOrderLine[scope.$index].spec, groupOrderLine[scope.$index])">
                            <span v-show="!groupOrderLine[scope.$index].isHideSpecLabel">规格：</span>
                            <span v-html="formatSpec(groupOrderLine[scope.$index].spec,groupOrderLine[scope.$index])"></span>
                          </div>
                          <div style="height:24px;" v-show="!formatSpec(groupOrderLine[scope.$index].spec,groupOrderLine[scope.$index])">
                          </div>
                          <div class="notMobile spec" v-show="groupOrderLine[scope.$index].sku"
                            style="position:relative;display: flex;">
                            <!--<span>货号：</span>-->
                            <span>{{ groupOrderLine[scope.$index].sku }}</span>
                          </div>
                          <div v-if="groupOrderLine[scope.$index].discounted_price !== groupOrderLine[scope.$index].price"
                            class="notMobile" style="display: flex;align-items: center;">
                            <a
                              class="order-price">{{ (groupOrderLine[scope.$index].discounted_price) | currency(order.currency_symbol) }}</a>
                            <del class="order-price">
                              {{ (groupOrderLine[scope.$index].price) | currency(order.currency_symbol) }}</del>
                          </div>
                          <div v-if="groupOrderLine[scope.$index].discounted_price == groupOrderLine[scope.$index].price"
                            class="notMobile" style="display: flex;align-items: center;">
                            <p class="order-price">
                              {{ (groupOrderLine[scope.$index].price) | currency(order.currency_symbol) }}</p>
                          </div>

                        </div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="申报信息" width="580">
                    <template slot-scope="scope">
                      <div style="margin-bottom:10px;display:flex;align-items:center;">
                          <div class="declare_info_left">
                            品名
                          </div>
                          <div>
                            <el-input v-model="scope.row.name" style="width:100px" @input="generateDesc1548"></el-input>
                          </div>
                      </div>
                      <div style="margin-bottom:10px;display:flex;align-items:center;">
                          <div class="declare_info_left">
                            数量
                          </div>
                          <div>
                            <el-input style="width:90px;" v-model="scope.row.quantity" type="InputNumber" @input="generateDesc1548"></el-input> 
                          </div>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
                <!--<el-table :data="form1548.goods" border style="margin:20px auto;width:400px;">
                  <el-table-column label="商品名称" width="329">
                    <template slot-scope="scope">
                      <el-input v-model="scope.row.name" style="width:100%" @input="generateDesc1548"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column label="数量" width="70">
                    <template slot-scope="scope">
                      <el-input v-model="scope.row.quantity" type="InputNumber" @input="generateDesc1548"></el-input>
                    </template>
                  </el-table-column>
                </el-table>-->
              </el-row>
              <el-row :gutter="20">
                <el-col :span="24">
                  <el-form-item label="收货地址" prop="address_id">
                    <el-select
                      :class="{ 'not_matched': form1548.address_id && address_list.find(i => i.value == form1548.address_id).match_index < 4 }"
                      placeholder="请选择地址" v-model="form1548.address_id" style="width:100%;">
                      <el-option v-for="item in address_list" class="aligh-left-select" :key="item.value"
                        :label="item.displayLabel" :value="item.value"
                        :disabled="item.account_id != form.transport_account_id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col v-if="form1548.address_id && address_list.find(i => i.value == form1548.address_id).match_index < 4"
                  :span="24">
                  <el-form-item label="正确地址">
                    <span v-if="address_list.find(i => i.value == form1548.address_id).match_index == 1">{{ order.address.mobile
                    }}</span>
                    {{ `${order.address.province + order.address.city + order.address.county} ${order.address.address1}` }}
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="增值服务" prop="invoice_removal">
                    <el-select v-model="form1548.adds2">
                      <el-option v-for="item in adds2_options" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="">
                    <div v-for="(item, index) in adds1_options" :key="index">
                      <el-checkbox v-model="adds1_check[index]">
                        {{ item.label }}
                      </el-checkbox>
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="24">
                  <el-form-item label="包裹描述" prop="mark">
                    <el-input type="textarea" v-model="form1548.mark"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </template>
            <template v-if="express_company_code == '15haoku'">
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="运输渠道" prop="channel">
                    <el-select v-model="formhaoku15.channel">
                      <el-option v-for="item in channels" class="aligh-left-select" :key="item.value" :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="包裹单号" prop="AWB">
                    {{ formhaoku15.AWB }}
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <div style="text-align: center;">商品列表({{ formhaoku15.weight?formhaoku15.weight:0 }})</div>
                <el-table :data="formhaoku15tabledata" border style="margin:20px auto;width:100%;" :span-method="objectSpanMethod">
                    <el-table-column label="商品信息" width="calc(100% - 580px)">
                      <template slot-scope="scope">
                        <div>
                          <div class="img-container">
                            <a :href='groupOrderLine[scope.$index].website.substr(0, 7).toLowerCase() == "https://" || groupOrderLine[scope.$index].website.substr(0, 8).toLowerCase() == "https://" ? groupOrderLine[scope.$index].website : "https://" + groupOrderLine[scope.$index].website'
                              target="_blank">
                              <img v-if="groupOrderLine[scope.$index].picture"
                                :src="groupOrderLine[scope.$index].picture" />
                              <img v-else src="https://pic.joyorders.com/blank.png" />
                              <span class="goodsNum"
                                v-if="groupOrderLine[scope.$index].number > 1">{{ groupOrderLine[scope.$index].number }}</span>
                            </a>
                          </div>
                          <div class="order-des">
                            <p class="name"><a
                                :href='groupOrderLine[scope.$index].website.substr(0, 7).toLowerCase() == "http://" || groupOrderLine[scope.$index].website.substr(0, 8).toLowerCase() == "https://" ? groupOrderLine[scope.$index].website : "http://" + groupOrderLine[scope.$index].website'
                                target="_blank">{{ groupOrderLine[scope.$index].name }}</a></p>
                            <div class="notMobile spec"
                              v-show="formatSpec(groupOrderLine[scope.$index].spec, groupOrderLine[scope.$index])">
                              <span v-show="!groupOrderLine[scope.$index].isHideSpecLabel">规格：</span>
                              <span v-html="formatSpec(groupOrderLine[scope.$index].spec,groupOrderLine[scope.$index])"></span>
                            </div>
                            <div style="height:24px;" v-show="!formatSpec(groupOrderLine[scope.$index].spec,groupOrderLine[scope.$index])">
                            </div>
                            <div class="notMobile spec" v-show="groupOrderLine[scope.$index].sku"
                              style="position:relative;display: flex;">
                              <!--<span>货号：</span>-->
                              <span>{{ groupOrderLine[scope.$index].sku }}</span>
                            </div>
                            <div v-if="groupOrderLine[scope.$index].discounted_price !== groupOrderLine[scope.$index].price"
                              class="notMobile" style="display: flex;align-items: center;">
                              <a
                                class="order-price">{{ (groupOrderLine[scope.$index].discounted_price) | currency(order.currency_symbol) }}</a>
                              <del class="order-price">
                                {{ (groupOrderLine[scope.$index].price) | currency(order.currency_symbol) }}</del>
                            </div>
                            <div v-if="groupOrderLine[scope.$index].discounted_price == groupOrderLine[scope.$index].price"
                              class="notMobile" style="display: flex;align-items: center;">
                              <p class="order-price">
                                {{ (groupOrderLine[scope.$index].price) | currency(order.currency_symbol) }}</p>
                            </div>

                          </div>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column label="申报信息" width="580">
                      <template slot-scope="scope">
                        <div v-for="item in scope.row.items">
                          <div style="margin-bottom:10px;display:flex;align-items:center;">
                              <div class="declare_info_left">
                                类别,中文名
                              </div>
                              <div>
                                {{ item.remark }},{{ item.name }}                 
                              </div>
                          </div>
                          <div style="margin-bottom:10px;display:flex;align-items:center;">
                              <div class="declare_info_left">
                                数量
                              </div>
                              <div>
                                {{ item.quantity }}
                              </div>
                          </div>
                        </div>
                      </template>
                    </el-table-column>
                  </el-table>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="24">
                  <el-form-item label="收货地址" prop="address_id">
                    <el-select placeholder="请选择地址" v-model="formhaoku15.address_id" style="width:100%;">
                      <el-option v-for="item in address_list" class="aligh-left-select" :key="item.value"
                        :label="item.displayLabel" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </template>
            <ul class="error-messages" v-if="submitError" style="margin-top: 15px;margin-bottom: -15px;">
              <li>{{ submitError }}</li>
            </ul>
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item label-width="0px">
                  <div style="width:50%;margin:40px auto 0;">
                    <el-button :loading="isSubmitting" class="block" type="info" @click="submitHandler('form')">提
                      交</el-button>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
          </template>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from '../../../services/api.js'
import HeaderSimple from '../../../components/HeaderSimple'
import Loading from '../../../components/Loading'
import { formatSpec } from '../../../services/tools.js'
import { COUNTRIES, specOrder, SPEC_MAPPER } from '../../../services/constant'
let _ = require('lodash')

export default {
  name: 'AddAddress',
  props: ['order', 'isSingle', 'mobiletype', 'trackTask', 'groupOrderLine', 'totalAccountList'],
  data() {
    return {
      formatSpec:formatSpec,
      baoguodanhao:'',
      totalChannels_beede:{},
      channels: [],
      other_service_list: [],
      dialogFormVisible: false,
      options: {},
      form_obj: {},
      source_map: {},
      submitError: '',
      isEmptyErrors: true,
      errors: null,
      isSubmitting: false,
      isGetFormData: false,
      totalList: [],
      errorMessage: '',
      transport_account_list: [],
      transport_company_list: [],
      account_id: this.$localStorage.get('account_id'),
      role: this.$localStorage.get('role'),
      rules: {},
      l1_other_service_list_total: [],
      formbeede: {
        channel:'',
        shipment_method:'0'
      },
      formhaoku15tabledata:[],
      formhaoku15: {
        channel:'',
        address_id:''
      },
      formzygjex: {
        type: 'normal',
        type1: {
          package_tracking_number_01: '',
          package_tracking_number_02: '',
          package_tracking_number_03: '',
          package_tracking_number_04: '',
          package_tracking_number_05: '',
          product_name_01: '',
          product_name_02: '',
          product_name_03: '',
          product_name_04: '',
          product_name_05: '',
        },
        type2: {
          tracking_no: '',
          l1_drop_down_list: '',
          l1_receiver: '',
          l1_product_list: [],
          l1_if_exist_dangerous_part: '否',
          l1_other_service_list: [],
          l1_baoxian_price: '',
          l1_remark: '',
          rate: 1,
        }
      },
      form1548: {
        ws_ordernum: '',
        ws_transnum: '',
        wz_url: '',
        auto_apply: '0',
        address_id: '',
        port_id: '',
        adds1: [],
        adds2: '',
        mark: '',
        goods: [],
      },
      port_options: [],
      adds1_options: [],
      adds1_check: [],
      adds2_options: [],
      form: {
        transport_company_id: '',
        transport_account_id: '',
        courier: '',
        package_tracking_number: '',
        declare_type: '',
        rate: '',
        product_list: [],
        address_id: '',
        items_counting: '',
        package_content_photos: '',
        invoice_removal: '',
        package_description: ''
      },
      formEWE:{
        warehouseId:'',
        carrierNo:'',
        type:'1',
        valueAddedList:[],
        serviceList:[],
        customerAddressId:'',
        nickname:'',
        goodsList:[]
      },
      formDF: {
        parcelExpress: '',
        parcelDescribe:'',
        expressNo: '',
        type: '',
        rate: '',
        detailList: [],
        linecode:'',
        takeOverId: '',
        serviceList:[],
      },
      formCPS: {
        stock_id: '',
        sn: '',
        express: '',
        goods: '',
        channel_id: '',
        vas_id_list:[],
        address_id: '',
        name:'',
        tel:'',
        country:'',
        province:'',
        city:'',
        county:'',
        address:'',
        package_description: ''
      },
      formBNS:{
        package_tracking_number: '',
        rate: '',
        product_list: [],
        battery_contained: '',
        share_for_reward: '',
        liquid_contained: '',
      },
      product_category_casader_list: [],
      warehouse_list: [],
      courier_list: [],
      shipping_route_list: [],
      address_list: [],
      vas_id_list:[],
      product_currency: '',
      declare_currency: '',
      product_rate: 0,
      no_need_warehouse_list: [418],
      original_product_list: [],
      subdomain:'',
    }
  },
  components: {
    HeaderSimple: HeaderSimple,
    Loading: Loading
  },
  computed: {
    express_company_code() {
      let arr = this.transport_company_list.filter(i => i.express_company_id == this.form.transport_company_id)
      if (arr.length)
        return arr[0].express_company_tag
      else
        return ''
    },
    hasDiffNum() {
      let hasDiffNum = false
      for (let i = 0, length = this.original_product_list.length; i < length; i++) {
        let num = 0;
        switch (this.express_company_code) {
          case 'bnsHK':
          case 'bnsMO':
            num = this.formBNS.product_list[i].product_quantity
            break;
          case 'cpszy':
            num = this.formCPS.goods[i].qty
            break;
          case 'dingfengzy':
            num = this.formDF.detailList[i].quantity
            break;
          case 'uszcn':
            num = this.form.product_list[i].product_quantity
            break;
          case 'ewe_us':
            num = this.formEWE.goodsList[i].quantity
            break;
          case 'zygjex':
            num = this.formzygjex.type2.l1_product_list[i].product_quantity
            break;
          case 'aozhuanyun':
            num = this.form1548.goods[i].quantity
            break;
          case 'ibeede':
            num = this.formbeede.product_list[i].product_quantity
            break;
        }
        if (this.original_product_list[i].num != num) {
          hasDiffNum = true
          break;
        }
      }
      return hasDiffNum;
    }
  },
  methods: {
    async searchSuggestAddress(query){
      this.suggestloading=true
      this.suggestAddressList=[]
      if(query){
        let res = await api.post(this, {
              path: 'order.php',
              api: 'search_transport_company_address_list',
              data: {
                keyword:query,
                transport_company_id:this.form.transport_company_id,
                zhuanyun_account_id:this.form.transport_account_id
              },
              loading: 'suggestloading'
        })
        this.suggestloading=false
        res = res.body
        if (res.status == 'ok') { 
          if(res.result.length){
            this.suggestAddressList=res.result.map((i)=>{
              return {
                id:i.zhuanyun_address_id,
                displayName:i.name+','+i.mobile+','+i.region+i.city+i.address+(i.identity_card.substr(0, 6) + 'XXXXXXXX' + i.identity_card.substr(13))
              }
            })
          }
        }
      }
      else{
        this.suggestAddressList=this.address_list
      }
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
        if (columnIndex === 1) {
          if (rowIndex === 0) {
            return {
              rowspan: this.formhaoku15tabledata.length,
              colspan: 1
            };
          } else {
            return {
              rowspan: 0,
              colspan: 0
            };
          }
        }
    },
    changeKeyField(data, field, scope, needRecaculatePrice) {
      if(field){
        if (data != this.original_product_list[scope.$index][field])
          this.original_product_list[scope.$index][field + '_diff'] = true
        else
          this.original_product_list[scope.$index][field + '_diff'] = false
      }
      if (needRecaculatePrice) {
        switch (this.express_company_code) {
          case 'uszcn':
            if (this.form.warehouse_id) {
              let o = this.form.product_list[scope.$index]
              o.declare_product_price = ((+o.declare_pre_product_price) * (+o.product_quantity)).toFixed(2)
            }
            this.generateDesc()
            break;
          case 'cpszy':
            if (this.formCPS.stock_id) {
              let o = this.formCPS.goods[scope.$index]
              o.declare_product_price = ((+o.declare_pre_product_price) * (+o.qty)).toFixed(2)
            }
            this.generateDescCPS()
            break;
          case 'dingfengzy':
            if (this.formDF.warehouse_id) {
              let o = this.formDF.detailList[scope.$index]
              o.declare_product_price = ((+o.declare_pre_product_price) * (+o.quantity)).toFixed(2)
            }
            this.generateDescDF()
            break;
          case 'zygjex':
            let o = this.formzygjex.type2.l1_product_list[scope.$index]
            o.declare_product_price = ((+o.declare_pre_product_price) * (+o.product_quantity)).toFixed(2)
            this.generateDesczygjex()
            break;
          case 'ibeede':
            let o_beede = this.formbeede.product_list[scope.$index]
            o_beede.declare_product_price = ((+o_beede.declare_pre_product_price) * (+o_beede.product_quantity)).toFixed(2)
            this.generateDescbeede()
            break;
          case 'ewe_us':
            let o_ewe_us = this.formEWE.goodsList[scope.$index]
            o_ewe_us.declare_product_price = ((+o_ewe_us.declare_pre_product_price) * (+o_ewe_us.quantity)).toFixed(2)
            this.generateDescEWE()
            break;

        }
      }
    },
    async remotetransportSearch(queryString, callback) {
      this.remoteAddress = []
      let res = this.address_list.filter((i) => {
        return i.name.toLowerCase().indexOf(queryString.toLowerCase()) > -1
      })
      _.each(res, item => {
        this.remoteAddress.push({ value: item.name, id: item.id })
      })
      if (callback)
        callback()
    },
    updateStore() {
      this.$store.commit('updateOpenDialog', false)
    },
    changeAddr(data) {
      if (data == 1) {
        this.form.address_id = ''
      }
      else {
        let addr_zycn = this.address_list.filter((a) => {
          return a.name == this.order.id_card_info.name && a.identity_card == this.order.id_card_info.id_card
        })
        if (addr_zycn.length)
          this.form.address_id = addr_zycn[0].value
      }
      this.generateDesc()
    },
    changeAddr1548(data) {
      this.generateDesc1548()
    },
    changeAddrzygjex(data) {
      this.generateDesczygjex()
    },
    changeAddrCPS(data){
      this.generateDescCPS()
    },
    changeAddrEWE(data){
      this.generateDescEWE()
    },
    changeAddrDF(data) {
      this.generateDescDF()
    },
    warehouse_change_beede(data){
      this.channels = this.totalChannels_beede[data]
    },
    warehouse_change_bns(data){
      if (this.source_map.declare_currency) {
            if (this.formBNS.warehouse_id) {
              let o = this.source_map.declare_currency.filter(i => i.value == this.formBNS.warehouse_id)[0].children[0]
              this.declare_currency = o.label
              this.formBNS.rate = o.rate
            }
            this.product_rate = this.formBNS.rate
          }
    },
    warehouse_change(data) {
      if (this.source_map.courier) {
        if (this.source_map.courier.filter(i => i.value == data).length)
          this.courier_list = this.source_map.courier.filter(i => i.value == data)[0].children;
        else
          this.courier_list = []
      }
      if (this.source_map.shipping_route) {
        if (this.source_map.shipping_route.filter(i => i.value == data).length)
          this.shipping_route_list = this.source_map.shipping_route.filter(i => i.value == data)[0].children;
        else
          this.shipping_route_list = []
      }
      if (this.source_map.declare_currency) {
        let o = this.source_map.declare_currency.filter(i => i.value == data)[0].children[0]
        this.declare_currency = o.label
        this.form.rate = o.rate
        this.form.product_list.forEach((a) => {
          if (a.product_currency != this.declare_currency){
            a.declare_pre_product_price = ((+a.product_price) * this.product_rate / this.form.rate).toFixed(2)
            a.declare_product_price = ((+a.product_price) * (+a.product_quantity) * this.product_rate / this.form.rate).toFixed(2)
          }
          else{
            a.declare_pre_product_price = a.product_price
            a.declare_product_price = ((+a.product_price) * (+a.product_quantity)).toFixed(2)
          }
        })
      }
      let shipping = this.order.shipping_info.filter(i => i.id == this.groupOrderLine[0].shipping_id)
      if (shipping.length) {
        let courier_arr = this.source_map.courier.filter(i => i.value == this.form.warehouse_id)[0].children
        let co = courier_arr.filter(i => shipping[0].express.toLowerCase().indexOf(i.label.toLowerCase()) > -1)
        let other = courier_arr.filter(i => i.label.toLowerCase() == 'other')
        if (co.length)
          this.form.courier = co[0].value
        else
          this.form.courier = other[0].value
      }
    },
    warehouse_change_cps(data) {
      if (this.source_map.channel_id) {
        if (this.source_map.channel_id.filter(i => i.value == data).length)
          this.shipping_route_list = this.source_map.channel_id.filter(i => i.value == data)[0].children;
        else
          this.shipping_route_list = []
      }
      if (this.source_map.vas_id_list) {
        if (this.source_map.vas_id_list.filter(i => i.value == data).length)
          this.vas_id_list = this.source_map.vas_id_list.filter(i => i.value == data)[0].children;
        else
          this.vas_id_list = []
      }
      let shipping = this.order.shipping_info.filter(i => i.id == this.groupOrderLine[0].shipping_id)
      if (shipping.length) {
        let courier_arr = this.source_map.courier.filter(i => i.value == this.formCPS.stock_id)[0].children
        let co = courier_arr.filter(i => shipping[0].express.toLowerCase().indexOf(i.label.toLowerCase()) > -1)
        let other = courier_arr.filter(i => i.label.toLowerCase() == 'other')
        if (co.length)
          this.formCPS.courier = co[0].value
        else
          this.formCPS.courier = other[0].value
      }
    },
    changeTransportCompany(d) {
      this.transport_account_list = this.totalList.filter(i => i.express_company_id == d)
        .map(i => { return { zhuanyun_account_id: i.zhuanyun_account_id, zhuanyun_account_name: i.zhuanyun_account_name } })

      if (this.transport_account_list.length)
        this.form.transport_account_id = this.transport_account_list[0].zhuanyun_account_id
      this.getInfo()
    },
    async show() {
      //this.getShangjiawuliudanhao()
      this.dialogFormVisible = true
      this.$store.commit('updateOpenDialog', true)
      let res = await api.getUserBindedAccountList(this)
      this.totalList = res.body.result;
      this.transport_company_list = []
      this.totalList.forEach(e => {
        if (this.transport_company_list.filter(i => i.express_company_id == e.express_company_id).length == 0)
          this.transport_company_list.push(e)
      });
      if (this.transport_company_list.filter(i => i.express_company_id == this.order.transport_express_id).length) {
        console.log('opem',this.form)
        this.form.transport_company_id = this.order.transport_express_id;
        let t = this.totalList.filter(i => i.express_company_id == this.form.transport_company_id)
        this.subdomain = t[0].subdomain?t[0].subdomain:'api';
        console.log('subdomain',this.subdomain);
        this.transport_account_list = t.map(i => { return { zhuanyun_account_id: i.zhuanyun_account_id, zhuanyun_account_name: i.zhuanyun_account_name } })
        if (this.totalAccountList && this.totalAccountList.filter(i=>i.express_company_id==this.form.transport_company_id).length) {
          this.form.transport_account_id = this.totalAccountList[0].account_id
        }
        else {
          if (this.transport_account_list.length)
            this.form.transport_account_id = this.transport_account_list[0].zhuanyun_account_id
        }
        switch (+this.form.transport_company_id) {
          case 899:
            let o = {
              package_tracking_number: [
                { required: true, message: '包裹跟踪单号是必填项' },
              ]
            }
            this.rules = Object.assign(this.rules, o)
            break;
        }
        await this.getInfo()
      }
    },
    submitHandler(formName) {
      switch (this.express_company_code) {
        case 'bnsHK':
        case 'bnsMO':
          this.submitFormBNS(formName);
          break;
        case 'ewe_us':
          this.submitFormEWE(formName);
          break;
        case 'uszcn':
          this.submitForm(formName);
          break;
        case 'cpszy':
          this.submitFormCPS(formName);
          break;
        case 'dingfengzy':
          this.submitFormDF(formName);
          break;
        case 'zygjex':
          this.submitFormZYGJEX(formName);
          break;
        case 'aozhuanyun':
          this.submitForm1548(formName);
          break;
        case '15haoku':
          this.submitFormhaoku15(formName);
          break;
        case 'ibeede':
          this.submitFormbeede(formName);
          break;
      }
    },
    submitFormZYGJEX(formName) {
      this.isEmptyErrors = true;
      this.errors = null;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let tablevalid = true
          if (tablevalid) {
            const confirm_address_submit = () => {
              this.submitEx()
            }
            const confirm_num_submit = () => {
              if (this.hasDiffNum) {
                this.$confirm('您提交申报的商品数量和初始数量不一致, 确认提交吗?', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  cancelButtonClass: 'customCancelButton',
                  confirmButtonClass: 'customConfirmButton',
                  center: true
                }).then(() => {
                  confirm_address_submit()
                }).catch(() => {
                });
              }
              else
                confirm_address_submit()
            }
            confirm_num_submit()
          }
        }
      });
    },
    submitForm1548(formName) {
      this.isEmptyErrors = true;
      this.errors = null;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let tablevalid = true
          if (tablevalid) {
            const confirm_address_submit = () => {
              if (!this.form1548.address_id)
                this.submitEx()
              else {
                if (this.form1548.address_id && this.address_list.find(i => i.value == this.form1548.address_id).match_index == 4) {
                  this.submitEx()
                } else {
                  this.$confirm('您提交申报的地址跟任务地址不完全匹配, 确认提交吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    cancelButtonClass: 'customCancelButton',
                    confirmButtonClass: 'customConfirmButton',
                    center: true
                  }).then(() => {
                    this.submitEx()
                  }).catch(() => {

                  });
                }
              }
            }
            const confirm_num_submit = () => {
              if (this.hasDiffNum) {
                this.$confirm('您提交申报的商品数量和初始数量不一致, 确认提交吗?', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  cancelButtonClass: 'customCancelButton',
                  confirmButtonClass: 'customConfirmButton',
                  center: true
                }).then(() => {
                  confirm_address_submit()
                }).catch(() => {
                });
              }
              else
                confirm_address_submit()
            }
            confirm_num_submit()
          }
        }
      });
    },
    submitFormhaoku15(formName) {
      this.isEmptyErrors = true;
      this.errors = null;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let tablevalid = true
          if (tablevalid) {
            const confirm_address_submit = () => {
              if (!this.formhaoku15.address_id)
                this.submitEx()
              else {
                this.submitEx()
                /*if(this.form1548.address_id && this.address_list.find(i=>i.value==this.form1548.address_id).match_index==4){
                  this.submitEx()
                }else{
                  this.$confirm('您提交申报的地址跟任务地址不完全匹配, 确认提交吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    cancelButtonClass:'customCancelButton',
                    confirmButtonClass:'customConfirmButton',
                    center: true
                  }).then(() => {
                    this.submitEx()              
                  }).catch(() => {
                          
                  });
                }*/
              }
            }
            
            const confirm_num_submit = () => {
              let hasDiffNum = false
              let totalNum = 0
              for (let i = 0, length = this.groupOrderLine.length; i < length; i++) {
                totalNum+=Number(this.groupOrderLine[i].number)
              }
              if (this.formhaoku15.summary[0].quantity != totalNum) {
                hasDiffNum = true;                
              }
              if (hasDiffNum) {
                this.$confirm('您提交申报的商品数量和初始数量不一致, 确认提交吗?', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  cancelButtonClass: 'customCancelButton',
                  confirmButtonClass: 'customConfirmButton',
                  center: true
                }).then(() => {
                  confirm_address_submit()
                }).catch(() => {
                });
              }
              else
                confirm_address_submit()
            }
            confirm_num_submit()
          }
        }
      });
    },
    submitFormbeede(formName){
      this.isEmptyErrors = true;
      this.errors = null;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let tablevalid = true
          if (tablevalid) {
            const confirm_address_submit = () => {
              if (!this.formbeede.address_id)
                this.submitEx()
              else {
                if (this.formbeede.address_id && this.address_list.find(i => i.value == this.formbeede.address_id).match_index == 4) {
                  this.submitEx()
                } else {
                  this.$confirm('您提交申报的地址跟任务地址不完全匹配, 确认提交吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    cancelButtonClass: 'customCancelButton',
                    confirmButtonClass: 'customConfirmButton',
                    center: true
                  }).then(() => {
                    this.submitEx()
                  }).catch(() => {

                  });
                }
              }
            }
              const confirm_num_submit = () => {
              if (this.hasDiffNum) {
                this.$confirm('您提交申报的商品数量和初始数量不一致, 确认提交吗?', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  cancelButtonClass: 'customCancelButton',
                  confirmButtonClass: 'customConfirmButton',
                  center: true
                }).then(() => {
                  confirm_address_submit()
                }).catch(() => {
                });
              }
              else
                confirm_address_submit()
            }
            confirm_num_submit()
          }
        }
      });
    },
    submitFormBNS(formName) {
      let product_map = {
        product_name: '填写商品名称',
        product_category_id_list: '选择商品分类',
        product_specifications: '填写商品型号',
        product_quantity: '填写商品数量',
        declare_product_price: '填写申报价格',
      }
      if(this.formBNS.share_for_reward=='yes')
        product_map.product_url='填写商品URL'
      this.isEmptyErrors = true;
      this.errors = null;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let tablevalid = true
          for (let i = 0, length = this.form.product_list.length; i < length; i++) {
            for (let p in this.form.product_list[i]) {
              if (p == 'product_category_id_list') {
                if (!this.form.product_list[i][p].length) {
                  tablevalid = false
                }
              }
              else {
                if (!this.form.product_list[i][p]) {
                  tablevalid = false
                }
              }
              if (!tablevalid) {
                this.isEmptyErrors = false
                this.errors = {
                  business_name: [
                    { message: '请' + product_map[p] }
                  ]
                }
                break;
              }
            }
            if (!tablevalid)
              break;
          }
          if (tablevalid) {
            const confirm_address_submit = () => {
              this.submitEx()
            }
            const confirm_num_submit = () => {
              if (this.hasDiffNum) {
                this.$confirm('您提交申报的商品数量和初始数量不一致, 确认提交吗?', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  cancelButtonClass: 'customCancelButton',
                  confirmButtonClass: 'customConfirmButton',
                  center: true
                }).then(() => {
                  confirm_address_submit()
                }).catch(() => {
                });
              }
              else
                confirm_address_submit()
            }
            confirm_num_submit()
          }
        }
      });
    },
    submitFormDF(formName){
      let product_map = {
        product_name: '填写商品名称',
        product_category_id_list: '选择商品分类',
        product_brand: '填写商品品牌',
        product_specifications: '填写商品型号',
        product_quantity: '填写商品数量',
        declare_product_price: '填写申报价格',
      }
      this.isEmptyErrors = true;
      this.errors = null;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let tablevalid = true
          for (let i = 0, length = this.formDF.detailList.length; i < length; i++) {
            for (let p in this.formDF.detailList[i]) {
              if (p == 'goodsType_list') {
                if (!this.formDF.detailList[i][p].length) {
                  tablevalid = false
                }
              }
              else {
                if (!this.formDF.detailList[i][p]) {
                  tablevalid = false
                }
              }
              if (!tablevalid) {
                this.isEmptyErrors = false
                this.errors = {
                  business_name: [
                    { message: '请' + product_map[p] }
                  ]
                }
                break;
              }
            }
            if (!tablevalid)
              break;
          }
          if (tablevalid) {
            const confirm_address_submit = () => {
              if (!this.formDF.takeOverId){
                if(this.formDF.type==2){
                  this.$confirm('您正在提交没有收件地址的货到即发申报, 提交后申报信息会是未完成的状态, 确认提交吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    cancelButtonClass: 'customCancelButton',
                    confirmButtonClass: 'customConfirmButton',
                    center: true
                  }).then(() => {
                    this.submitEx()
                  }).catch(() => {

                  });
                }
                else
                  this.submitEx()
              }
              else {
                if (this.formDF.takeOverId && this.address_list.find(i => i.value == this.formDF.takeOverId).match_index == 4) {
                  this.submitEx()
                } else {
                  this.$confirm('您提交申报的地址跟任务地址不完全匹配, 确认提交吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    cancelButtonClass: 'customCancelButton',
                    confirmButtonClass: 'customConfirmButton',
                    center: true
                  }).then(() => {
                    this.submitEx()
                  }).catch(() => {

                  });
                }
              }
            }
            const confirm_num_submit = () => {
              if (this.hasDiffNum) {
                this.$confirm('您提交申报的商品数量和初始数量不一致, 确认提交吗?', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  cancelButtonClass: 'customCancelButton',
                  confirmButtonClass: 'customConfirmButton',
                  center: true
                }).then(() => {
                  confirm_address_submit()
                }).catch(() => {
                });
              }
              else
                confirm_address_submit()
            }
            confirm_num_submit()
          }
        }
      });
    },
    submitFormCPS(formName){
      let product_map = {
        product_name: '填写商品名称',
        product_category_id_list: '选择商品分类',
        product_brand: '填写商品品牌',
        product_specifications: '填写商品型号',
        product_quantity: '填写商品数量',
        declare_product_price: '填写申报价格',
      }
      this.isEmptyErrors = true;
      this.errors = null;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let tablevalid = true
          for (let i = 0, length = this.formCPS.goods.length; i < length; i++) {
            for (let p in this.formCPS.goods[i]) {
              if (p == 'product_category_id_list') {
                if (!this.formCPS.goods[i][p].length) {
                  tablevalid = false
                }
              }
              else {
                if (!this.formCPS.goods[i][p]) {
                  tablevalid = false
                }
              }
              if (!tablevalid) {
                this.isEmptyErrors = false
                this.errors = {
                  business_name: [
                    { message: '请' + product_map[p] }
                  ]
                }
                break;
              }
            }
            if (!tablevalid)
              break;
          }
          if (tablevalid) {
            const confirm_address_submit = () => {
              if (!this.formCPS.address_id){
                this.submitEx()
              }
              else {
                if (this.formCPS.address_id && this.address_list.find(i => i.value == this.formCPS.address_id).match_index == 4) {
                  this.submitEx()
                } else {
                  this.$confirm('您提交申报的地址跟任务地址不完全匹配, 确认提交吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    cancelButtonClass: 'customCancelButton',
                    confirmButtonClass: 'customConfirmButton',
                    center: true
                  }).then(() => {
                    this.submitEx()
                  }).catch(() => {

                  });
                }
              }
            }
            const confirm_num_submit = () => {
              if (this.hasDiffNum) {
                this.$confirm('您提交申报的商品数量和初始数量不一致, 确认提交吗?', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  cancelButtonClass: 'customCancelButton',
                  confirmButtonClass: 'customConfirmButton',
                  center: true
                }).then(() => {
                  confirm_address_submit()
                }).catch(() => {
                });
              }
              else
                confirm_address_submit()
            }
            confirm_num_submit()
          }
        }
      });
    },
    submitFormEWE(formName){
      let product_map = {
        goodsName: '填写商品名称',
        goodsType_list: '选择商品分类',
        brand: '填写商品品牌',
        goodsModel: '填写商品型号',
        quantity: '填写商品数量',
        goodsPrice: '填写申报价格',
      }
      this.isEmptyErrors = true;
      this.errors = null;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let tablevalid = true
          for (let i = 0, length = this.formEWE.goodsList.length; i < length; i++) {
            for (let p in this.formEWE.goodsList[i]) {
              if (p == 'goodsType_list') {
                if (!this.formEWE.goodsList[i][p].length) {
                  tablevalid = false
                }
              }
              else {
                if (!this.formEWE.goodsList[i][p]) {
                  tablevalid = false
                }
              }
              if (!tablevalid) {
                this.isEmptyErrors = false
                this.errors = {
                  business_name: [
                    { message: '请' + product_map[p] }
                  ]
                }
                break;
              }
            }
            if (!tablevalid)
              break;
          }
          if (tablevalid) {
            const confirm_address_submit = () => {
              if (!this.formEWE.customerAddressId){
                if(this.formEWE.type==2){
                  this.$confirm('您正在提交没有收件地址的货到即发申报, 提交后申报信息会是未完成的状态, 确认提交吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    cancelButtonClass: 'customCancelButton',
                    confirmButtonClass: 'customConfirmButton',
                    center: true
                  }).then(() => {
                    this.submitEx()
                  }).catch(() => {

                  });
                }
                else
                  this.submitEx()
              }
              else {
                this.submitEx()
              }
            }
            const confirm_num_submit = () => {
              if (this.hasDiffNum) {
                this.$confirm('您提交申报的商品数量和初始数量不一致, 确认提交吗?', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  cancelButtonClass: 'customCancelButton',
                  confirmButtonClass: 'customConfirmButton',
                  center: true
                }).then(() => {
                  confirm_address_submit()
                }).catch(() => {
                });
              }
              else
                confirm_address_submit()
            }
            confirm_num_submit()
          }
        }
      });
    },
    submitForm(formName) {
      let product_map = {
        product_name: '填写商品名称',
        product_category_id_list: '选择商品分类',
        product_brand: '填写商品品牌',
        product_specifications: '填写商品型号',
        product_quantity: '填写商品数量',
        declare_product_price: '填写申报价格',
      }
      this.isEmptyErrors = true;
      this.errors = null;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let tablevalid = true
          for (let i = 0, length = this.form.product_list.length; i < length; i++) {
            for (let p in this.form.product_list[i]) {
              if (p == 'product_category_id_list') {
                if (!this.form.product_list[i][p].length) {
                  tablevalid = false
                }
              }
              else {
                if (!this.form.product_list[i][p]) {
                  tablevalid = false
                }
              }
              if (!tablevalid) {
                this.isEmptyErrors = false
                this.errors = {
                  business_name: [
                    { message: '请' + product_map[p] }
                  ]
                }
                break;
              }
            }
            if (!tablevalid)
              break;
          }
          if (tablevalid) {
            const confirm_address_submit = () => {
              if (!this.form.address_id){
                if(this.form.declare_type==2){
                  this.$confirm('您正在提交没有收件地址的货到即发申报, 提交后申报信息会是未完成的状态, 确认提交吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    cancelButtonClass: 'customCancelButton',
                    confirmButtonClass: 'customConfirmButton',
                    center: true
                  }).then(() => {
                    this.submitEx()
                  }).catch(() => {

                  });
                }
                else
                  this.submitEx()
              }
              else {
                if (this.form.address_id && this.address_list.find(i => i.value == this.form.address_id).match_index == 4) {
                  this.submitEx()
                } else {
                  this.$confirm('您提交申报的地址跟任务地址不完全匹配, 确认提交吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    cancelButtonClass: 'customCancelButton',
                    confirmButtonClass: 'customConfirmButton',
                    center: true
                  }).then(() => {
                    this.submitEx()
                  }).catch(() => {

                  });
                }
              }
            }
            const confirm_num_submit = () => {
              if (this.hasDiffNum) {
                this.$confirm('您提交申报的商品数量和初始数量不一致, 确认提交吗?', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  cancelButtonClass: 'customCancelButton',
                  confirmButtonClass: 'customConfirmButton',
                  center: true
                }).then(() => {
                  confirm_address_submit()
                }).catch(() => {
                });
              }
              else
                confirm_address_submit()
            }
            confirm_num_submit()
          }
        }
      });
    },
    generateName(list) {
      let arr = this.product_category_casader_list
      let index = 0;
      let result = ''
      let findName = (data, l) => {
        let r = data.filter(i => i.value == l[index])
        if (index == l.length - 1) {
          result = r[0].label
        }
        else {
          index++;
          findName(r[0].children, l)
        }
      }
      findName(arr, list)
      return result
    },
    async submitEx() {
      this.submitError = ''
      let params = {}
      params.order_id = this.order.id
      params.transport_account_id = this.form.transport_account_id
      switch (this.express_company_code) {
        case 'uszcn':
          params.package_data = JSON.parse(JSON.stringify(this.form));
          params.package_data.product_list.forEach((i) => {
            i.product_price = i.declare_pre_product_price
            i.total_price = i.declare_product_price
          })
          break;
        case 'ewe_us':
          params.package_data = JSON.parse(JSON.stringify(this.formEWE));
          params.package_data.product_list.forEach((i) => {
            i.goodsPrice = i.declare_pre_product_price
            i.total_price = i.declare_product_price
          })
          break;
        case 'cpszy':
          params.package_data = JSON.parse(JSON.stringify(this.formCPS));
          params.package_data.goods.forEach((i) => {
            i.price = i.declare_pre_product_price
            i.total_price = i.declare_product_price
          })
          break;
        case 'dingfengzy':
          params.package_data = JSON.parse(JSON.stringify(this.formDF));
          params.package_data.detailList.forEach((i) => {
            i.goodsPrice = i.declare_pre_product_price
            i.total_price = i.declare_product_price
          })
          break;
        case 'bnsHK':
        case 'bnsMO':
          params.package_data = JSON.parse(JSON.stringify(this.formBNS));
          params.package_data.product_list.forEach((i) => {
            i.product_price = i.declare_pre_product_price
            i.total_price = i.declare_product_price
          })
          break;
        case 'ibeede':
          params.package_data = JSON.parse(JSON.stringify(this.formbeede));
          params.package_data.product_list.forEach((i) => {
            i.product_price = i.declare_pre_product_price
            i.total_price = i.declare_product_price
          })
          break;
        case 'zygjex':
          if (this.formzygjex.type == 'normal')
            params.package_data = JSON.parse(JSON.stringify(this.formzygjex.type1));
          else {
            this.formzygjex.type2.l1_other_service_list = this.l1_other_service_list_total.filter(i => i)
            params.package_data = JSON.parse(JSON.stringify(this.formzygjex.type2));
          }
          params.package_data.type = this.formzygjex.type
          break;
        case 'aozhuanyun':
          this.form1548.adds1 = []
          this.adds1_check.forEach((i, index) => {
            if (i)
              this.form1548.adds1.push(this.adds1_options[index].value)
          })
          params.package_data = JSON.parse(JSON.stringify(this.form1548));
          break;
        case '15haoku':
          params.package_data = JSON.parse(JSON.stringify(this.formhaoku15));
          break;
      }
      /*params.package_data.product_list.forEach((p)=>{
        //p.product_name=this.generateName(p.product_category_id_list)
        p.product_name=
      })*/
      params.subdomain = this.subdomain
      this.isSubmitting = true;
      //console.log('submit',params)
      //return;
      let res = await api.submitTransportFormData(this, params);
      this.isSubmitting = false
      if (res.body.status == 'ok') {
        this.dialogFormVisible = false;
        Object.assign(this.order, res.body.result)
        this.order.groupOrderLines = _.groupBy(this.order.goods_list, 'package_id')
        this.$store.commit('updateMessageDialog', { visible: true, message: '包裹预报成功' })
      }
      else
        this.submitError = res.body.result
    },
    getSpec(s) {
      try {
        let spec = s.spec.replace(/\n/g, '')
        spec = JSON.parse(spec)
        if (spec.spec) {
          return ''
        }
        else {
          return spec[s.vice_param] || ''
        }
      } catch (error) {
        return ''
      }
    },
    generateFormData(data) {
      const s = { 1: '正常', 2: '审核中', 3: '审核异常' }
      let shipping = this.order.shipping_info.filter(i => i.id == this.groupOrderLine[0].shipping_id)
      switch (this.express_company_code) {
        case '1234':
          let packageNum = 0;
          for (let key in this.order.groupOrderLines) {
            packageNum++;
          }
          this.form.declare_type = packageNum > 1 ? "1" : "2"
          break;
        case 'ibeede':
          this.warehouse_list = data.filter(i => i.field == 'warehouse')[0].options
          this.formbeede.warehouse=data.filter(i => i.field == 'warehouse')[0].value
          this.totalChannels_beede = data.filter(i => i.field == 'channel')[0].options
          if(this.formbeede.warehouse){
            this.channels = this.totalChannels_beede[this.formbeede.warehouse]
            this.formbeede.channel=data.filter(i => i.field == 'channel')[0].value || '49'
          }
          this.formbeede.AWB = data.filter(i => i.field == 'AWB')[0].value;
          this.formbeede.product_list = data.filter(i => i.field == 'product_list')[0].value
          let glist_beede = data.filter(i => i.field == 'product_list')[0]
          this.product_category_casader_list = glist_beede.props.rules.filter(i => i.field == 'product_category_id_list')[0].props.options
          //this.form.rate=
          this.formbeede.product_list.forEach((a) => {
          if (a.product_currency != 'USD'){
            this.$set(a, 'declare_pre_product_price', ((+a.product_price)* a.product_rate / a.usd_rate).toFixed(2));
            a.declare_product_price = ((+a.product_price) * (+a.product_quantity) * a.product_rate / a.usd_rate).toFixed(2)
          }
          else{
            a.declare_product_price = ((+a.product_price) * (+a.product_quantity)).toFixed(2);
            this.$set(a, 'declare_pre_product_price', a.product_price);
          }
        })
          this.original_product_list = []
          this.formbeede.product_list.forEach((g) => {
            this.original_product_list.push({ name: g.product_name, num: g.product_quantity })
          })
          this.address_list = data.filter(i => i.field == 'address_id')[0].options
          this.address_list.forEach((a) => {
            a.displayLabel = `${a.status != 1 ? s[a.status] : ''} 匹配度${a.match_index} ${a.account_name} ${a.label} ${a.full_address} ${a.identity_card.substr(0, 6) + 'XXXXXXXX' + a.identity_card.substr(13)}`
          })
          let addr_beede = this.address_list.filter((a) => {
            return a.name == this.order.id_card_info.name && a.identity_card == this.order.id_card_info.id_card
          })
          if (addr_beede.length)
            this.formbeede.address_id = addr_beede[0].value
          this.generateDescbeede()
          break;
        case '15haoku':
          this.channels = data.filter(i => i.field == 'channel')[0].options
          this.formhaoku15.channel = data.filter(i => i.field == 'channel')[0].value
          this.formhaoku15.AWB = data.filter(i => i.field == 'AWB')[0].value;
          this.formhaoku15.weight = data.filter(i => i.field == 'weight')[0].value;
          this.formhaoku15.summary = data.filter(i => i.field == 'summary')[0].options
          if(this.formhaoku15.summary.length){
            this.formhaoku15tabledata=[]
            this.groupOrderLine.forEach((i)=>{
              this.formhaoku15tabledata.push({items:this.formhaoku15.summary})
            })
          }
          this.address_list = data.filter(i => i.field == 'address_id')[0].options
          this.address_list.forEach((a) => {
            a.displayLabel = `${a.status != 1 ? s[a.status] : ''} 匹配度${a.match_index} ${a.account_name} ${a.label} ${a.full_address} ${a.identity_card.substr(0, 6) + 'XXXXXXXX' + a.identity_card.substr(13)}`
          })
          let addr_haoku15 = this.address_list.filter((a) => {
            return a.name == this.order.id_card_info.name && a.identity_card == this.order.id_card_info.id_card
          })
          if (addr_haoku15.length)
            this.formhaoku15.address_id = addr_haoku15[0].value
          break;
        case 'zygjex':
          let data1 = data.normal
          let data2 = data.huodaojifa
          if (shipping.length) {
            this.formzygjex.type2.tracking_no = shipping[0].AWB.replace(/:.*/, '');
            this.formzygjex.type1.package_tracking_number_01 = shipping[0].AWB.replace(/:.*/, '');
          }
          //this.formzygjex.type2.tracking_no=this.order.business_order_no         
          this.formzygjex.type2.l1_product_list = data2.filter(i => i.field == 'l1_product_list')[0].value
          this.original_product_list = []
          this.formzygjex.type2.l1_product_list.forEach((g) => {
            this.original_product_list.push({ name: g.product_name_cn, num: g.product_quantity })
          })
          this.formzygjex.type2.rate = this.formzygjex.type2.l1_product_list[0].declare_rate
          this.declare_currency = this.formzygjex.type2.l1_product_list[0].declare_currency
          this.product_currency = this.formzygjex.type2.l1_product_list[0].product_currency
          this.formzygjex.type2.l1_baoxian_price = data2.filter(i => i.field == 'l1_baoxian_price')[0].value
          this.other_service_list = data2.filter(i => i.field == 'l1_other_service_list')[0].options
          this.l1_other_service_list_total = new Array(this.other_service_list.length)
          this.port_options = data2.filter(i => i.field == 'l1_drop_down_list')[0].options
          this.address_list = data2.filter(i => i.field == 'l1_receiver')[0].options
          this.address_list.forEach((a) => {
            a.displayLabel = `${a.label}`
          })
          this.formzygjex.type2.l1_product_list.forEach((a, index) => {
            this.$set(a, 'declare_pre_product_price', ((+a.product_price) * this.formzygjex.type2.rate / 1).toFixed(2));
            a.declare_product_price = ((+a.product_price) * (+a.product_quantity) * this.formzygjex.type2.rate / 1).toFixed(2)
          })
          let addr_zygjex = this.address_list.filter((a) => {
            return a.name == this.order.id_card_info.name && a.identity_card == this.order.id_card_info.id_card
          })
          if (addr_zygjex.length)
            this.formzygjex.type2.l1_receiver = addr_zygjex[0].value
          this.generateDesczygjex()
          break;
        case 'aozhuanyun':
          this.form1548.ws_ordernum = this.baoguodanhao
          if (shipping.length)
            this.form1548.ws_transnum = shipping[0].AWB.replace(/:.*/, '');
          let wz_url = data.filter(i => i.field == 'wz_url')[0]
          this.form1548.wz_url = wz_url.value
          this.form1548.goods = data.filter(i => i.field == 'goods')[0].value
          this.original_product_list = []
          this.form1548.goods.forEach((g) => {
            this.original_product_list.push({ name: g.name, num: g.quantity })
          })
          this.port_options = data.filter(i => i.field == 'port_id')[0].options

          /*if(this.form1548.goods.length==1 && (+this.form1548.goods[0].price)>=200)
            this.form1548.port_id=1
          else
            this.form1548.port_id=0*/
          
          /*if(){
            this.form1548.auto_apply='1'
          }
          else
            this.form1548.auto_apply='0'*/
          this.adds1_options = data.filter(i => i.field == 'adds1')[0].options
          this.adds2_options = data.filter(i => i.field == 'adds2')[0].options
          this.form1548.adds2 = data.filter(i => i.field == 'adds2')[0].value
          this.address_list = data.filter(i => i.field == 'address_id')[0].options
          this.address_list.forEach((a) => {
            a.displayLabel = `${a.status != 1 ? s[a.status] : ''} 匹配度${a.match_index} ${a.account_name} ${a.label} ${a.full_address} ${a.identity_card.substr(0, 6) + 'XXXXXXXX' + a.identity_card.substr(13)}`
          })
          let addr = this.address_list.filter((a) => {
            return a.name == this.order.id_card_info.name && a.identity_card == this.order.id_card_info.id_card
          })
          if (addr.length)
            this.form1548.address_id = addr[0].value
          this.generateDesc1548()
          break;
        case 'bnsHK':
        case 'bnsMO':
          this.warehouse_list = data.filter(i => i.field == 'warehouse_id')[0].options

          let countryname_bns = COUNTRIES.filter(i => i.value == this.order.business.country)[0].name
          //if(a.length)
          let wa_bns = this.warehouse_list.filter(i => i.label.indexOf(countryname_bns) > -1)
          if (this.no_need_warehouse_list.indexOf(+this.order.business_id) == -1) {
            if (wa_bns.length)
              this.formBNS.warehouse_id = wa_bns[0].value
          }
          let glist_bns = data.filter(i => i.field == 'product_list')[0]

          this.product_category_casader_list = glist_bns.props.rules.filter(i => i.field == 'product_category_id_list')[0].props.options
          if (this.source_map.declare_currency) {
            if (this.formBNS.warehouse_id) {
              let o = this.source_map.declare_currency.filter(i => i.value == this.formBNS.warehouse_id)[0].children[0]
              this.declare_currency = o.label
              this.formBNS.rate = o.rate
            }
            let t = this.source_map.declare_currency.filter((i) => {
              return i.children.filter(u => u.value == glist_bns.value[0].product_currency).length > 0
            })
            if (t.length)
              this.product_rate = t[0].children[0].rate
            if (glist_bns.value[0].product_currency == 'CNY')
              this.product_rate = 1
          }
          this.formBNS.product_list = glist_bns.value
          this.formBNS.product_list.forEach((a, index) => {
            a.product_specifications = this.getSpec(this.groupOrderLine[index]) || this.formatSpec(this.groupOrderLine[index].spec)
            if (this.formBNS.warehouse_id) {
              if (a.product_currency != this.declare_currency){
                this.$set(a, 'declare_pre_product_price', ((+a.product_price) * this.product_rate / this.form.rate).toFixed(2));
                a.declare_product_price = ((+a.product_price) * (+a.product_quantity) * this.product_rate / this.form.rate).toFixed(2)
              }
              else{
                this.$set(a, 'declare_pre_product_price', a.product_price);
                a.declare_product_price = ((+a.product_price) * (+a.product_quantity)).toFixed(2)
              }
            }
            else
              a.declare_product_price = ''
          })
          this.original_product_list = []
          this.formBNS.product_list.forEach((g) => {
            this.original_product_list.push({ name: g.product_name, num: g.product_quantity })
          })
          this.product_currency = this.formBNS.product_list[0].product_currency
          if (shipping.length) {
            this.formBNS.package_tracking_number = shipping[0].AWB.replace(/:.*/, '')
          }

          //this.generateDescBNS()

          this.formBNS.share_for_reward = 'no'
          this.formBNS.liquid_contained = 'no'
          this.formBNS.battery_contained = 'no'
          break;
        case 'cpszy':
            this.warehouse_list = data.filter(i => i.field == 'stock_id')[0].options
            this.courier_list = data.filter(i => i.field == 'express')[0].options
            this.shipping_route_list = data.filter(i => i.field == 'channel_id')[0].options
            this.vas_id_list = data.filter(i => i.field == 'vas_id_list')[0].options
            if(data.filter(i => i.field == 'address_list').length){
              this.address_list = data.filter(i => i.field == 'address_list')[0].options
              this.address_list.forEach((a) => {
                a.displayLabel = a.value
              })
            }
            else{
              this.formCPS.name=data.filter(i => i.field == 'name')[0].value
              this.formCPS.tel=data.filter(i => i.field == 'tel')[0].value
              this.formCPS.country=data.filter(i => i.field == 'country')[0].value
              this.formCPS.province=data.filter(i => i.field == 'province')[0].value
              this.formCPS.city=data.filter(i => i.field == 'city')[0].value
              this.formCPS.county=data.filter(i => i.field == 'county')[0].value
              this.formCPS.address=data.filter(i => i.field == 'address')[0].value
              this.formCPS.idCard=data.filter(i => i.field == 'idCard')[0].value
              this.formCPS.idCard=data.filter(i => i.field == 'idCard')[0].value
              this.formCPS.idCardFront=data.filter(i => i.field == 'idCardFront')[0].value
              this.formCPS.idCardBack=data.filter(i => i.field == 'idCardBack')[0].value
              this.formCPS.fullAddress=`${data.filter(i => i.field == 'name')[0].value}${data.filter(i => i.field == 'tel')[0].value}${data.filter(i => i.field == 'country')[0].value}${data.filter(i => i.field == 'province')[0].value}${data.filter(i => i.field == 'city')[0].value}${data.filter(i => i.field == 'county')[0].value}${data.filter(i => i.field == 'address')[0].value}${this.formCPS.idCard.substr(0, 6) + 'XXXXXXXX' + this.formCPS.idCard.substr(13)}`
            }
            this.formCPS.stock_id = data.filter(i => i.field == 'stock_id')[0].value
            this.formCPS.express = this.courier_list[0].value
            this.formCPS.channel_id = data.filter(i => i.field == 'channel_id')[0].value
            this.formCPS.type = "1"
            if (shipping.length)
              this.formCPS.sn = shipping[0].AWB.replace(/:.*/, '');
            //let countryname_cps = COUNTRIES.filter(i => i.value == this.order.business.country)[0].name
            //if(a.length)
            /*let wa_cps = this.warehouse_list.filter(i => i.label.indexOf(countryname_cps) > -1)
            if (this.no_need_warehouse_list.indexOf(+this.order.business_id) == -1) {
              if (wa_cps.length)
                this.formCPS.stock_id = wa_cps[0].value
            }*/
            let glist_cps = data.filter(i => i.field == 'goods')[0]

            this.product_category_casader_list = glist_cps.props.rules.filter(i => i.field == 'category')[0].options
            let usd_rate = data.filter(i => i.field == 'declare_currency_usd')[0].value
            
            this.formCPS.goods = glist_cps.value
            this.formCPS.goods.forEach((a, index) => {
              if(index==0){
                this.declare_currency = a.currency
                if(this.declare_currency!='USD')
                  this.formCPS.rate = ((+a.currency_rate)/(+usd_rate)).toFixed(2)
                else
                  this.formCPS.rate = 1
              }
              a.size = this.getSpec(this.groupOrderLine[index]) || this.formatSpec(this.groupOrderLine[index].spec)
              this.$set(a, 'declare_pre_product_price', ((+a.price) * this.formCPS.rate).toFixed(2));
              a.declare_product_price = ((+a.price) * (+a.qty) * this.formCPS.rate).toFixed(2)
            })
            this.original_product_list = []
            this.formCPS.goods.forEach((g) => {
              this.original_product_list.push({ name: g.product_name, num: g.qty })
            })
            this.product_currency = this.formCPS.goods[0].product_currency
            if (shipping.length) {
              this.formCPS.package_tracking_number = shipping[0].AWB.replace(/:.*/, '')
              /*if (this.formCPS.stock_id) {
                let courier_arr = this.source_map.courier.filter(i => i.value == this.formCPS.stock_id)[0].children
                let co = courier_arr.filter(i => shipping[0].express.toLowerCase().indexOf(i.label.toLowerCase()) > -1)
                let other = courier_arr.filter(i => i.label.toLowerCase() == 'other')
                if (co.length)
                  this.formCPS.courier = co[0].value
                else
                  this.formCPS.courier = other[0].value
              }*/
            }


            if (this.formCPS.type == 2 && data.filter(i => i.field == 'address_id')[0] && data.filter(i => i.field == 'address_id')[0].options.length) {
              let addr_zycn = this.address_list.filter((a) => {
                return a.name == this.order.id_card_info.name && a.identity_card == this.order.id_card_info.id_card
              })
              if (addr_zycn.length)
                this.formCPS.address_id = addr_zycn[0].value
            }
            //this.form.address_id=data.filter(i=>i.field=='address_id')[0].options[0].value

            this.generateDescCPS()

            break;
        case 'dingfengzy':
            //this.warehouse_list = data.filter(i => i.field == 'warehouse_id')[0].options
            this.courier_list = data.filter(i => i.field == 'parcelExpress')[0].options
            this.shipping_route_list = data.filter(i => i.field == 'linecode')[0].options
            this.formDF.linecode = this.shipping_route_list[0].value;
            this.formDF.parcelExpress = this.courier_list[0].value;
            this.vas_id_list = data.filter(i => i.field == 'serviceList')[0].options
            this.address_list = data.filter(i => i.field == 'takeOverId')[0].options
            this.address_list.forEach((a) => {
              a.displayLabel = `${a.status != 1 ? s[a.status] : ''} 匹配度${a.match_index} ${a.account_name} ${a.label} ${a.full_address} ${a.identity_card.substr(0, 6) + 'XXXXXXXX' + a.identity_card.substr(13)}`
            })
            if(this.address_list.length)
              this.formDF.takeOverId = this.address_list[0].value;
            
            let glist_df = data.filter(i => i.field == 'detailList')[0]

            this.product_category_casader_list = glist_df.props.rules.filter(i => i.field == 'goodsType_list')[0].props.options
            
            this.formDF.detailList = glist_df.value
            this.formDF.detailList.forEach((a, index) => {
              a.goodsModel = this.getSpec(this.groupOrderLine[index]) || this.formatSpec(this.groupOrderLine[index].spec)
              a.declare_product_price = ((+a.goodsPrice) * (+a.quantity) * a.declare_rate).toFixed(2)
              this.$set(a, 'declare_pre_product_price', ((+a.goodsPrice) * a.declare_rate).toFixed(2));
            })
            this.declare_currency = 'CNY'
            this.original_product_list = []
            this.formDF.detailList.forEach((g) => {
              this.original_product_list.push({ name: g.goodsName, num: g.quantity })
            })
            this.product_currency = this.formDF.detailList[0].product_currency
            if (shipping.length) {
              this.formDF.expressNo = shipping[0].AWB.replace(/:.*/, '')
            }

            this.formDF.type = data.filter(i => i.field == 'type')[0].value

            if (this.formDF.type == 2 && data.filter(i => i.field == 'address_id')[0] && data.filter(i => i.field == 'address_id')[0].options.length) {
              let addr_zycn = this.address_list.filter((a) => {
                return a.name == this.order.id_card_info.name && a.identity_card == this.order.id_card_info.id_card
              })
              if (addr_zycn.length)
                this.formDF.address_id = addr_zycn[0].value
            }
            //this.form.address_id=data.filter(i=>i.field=='address_id')[0].options[0].value

            this.generateDescDF()

            this.formDF.shipping_route = 'default'
            break;
        case 'ewe_us':
          this.warehouse_list = data.filter(i => i.field == 'warehouseId')[0].options
          
          //let wa_ewe = this.warehouse_list.filter(i => i.value==)
          //if (wa_ewe.length)
          this.formEWE.warehouseId = data.filter(i => i.field == 'warehouseId')[0].value
          let glist_ewe = data.filter(i => i.field == 'goodsList')[0]

          this.product_category_casader_list = glist_ewe.props.rules.filter(i => i.field == 'category_list')[0].props.options
          
          this.formEWE.goodsList = glist_ewe.value
          this.declare_currency = this.formEWE.goodsList[0].currency
          this.form.rate = this.formEWE.goodsList[0].declare_rate
          this.vas_id_list = data.filter(i => i.field == 'valueAddedList')[0].options
          this.address_list = data.filter(i => i.field == 'customerAddressId')[0].options
          this.channels = data.filter(i => i.field == 'orderType')[0].options
          this.address_list.forEach((a) => {
            a.displayLabel = `${a.account_name} ${a.label} ${a.full_address} ${a.identity_card.substr(0, 6) + 'XXXXXXXX' + a.identity_card.substr(13)}`
          })
          this.original_product_list = []
          this.formEWE.goodsList.forEach((g) => {
            this.original_product_list.push({ name: g.goodsName, num: g.quantity })
          })
          this.formEWE.goodsList.forEach((a, index) => {
              a.declare_product_price = ((+a.goodsPrice) * (+a.quantity) * a.declare_rate).toFixed(2)
              this.$set(a, 'declare_pre_product_price', ((+a.goodsPrice) * a.declare_rate).toFixed(2));
            })
          if (shipping.length) {
            this.formEWE.carrierNo = shipping[0].AWB.replace(/:.*/, '')
          }

          this.generateDescEWE()
          break;
        case 'uszcn':
          this.warehouse_list = data.filter(i => i.field == 'warehouse_id')[0].options
          this.courier_list = data.filter(i => i.field == 'courier')[0].options
          this.shipping_route_list = data.filter(i => i.field == 'shipping_route')[0].options
          this.address_list = data.filter(i => i.field == 'address_id')[0].options
          this.address_list.forEach((a) => {
            a.displayLabel = `${a.status != 1 ? s[a.status] : ''} 匹配度${a.match_index} ${a.account_name} ${a.label} ${a.full_address} ${a.identity_card.substr(0, 6) + 'XXXXXXXX' + a.identity_card.substr(13)}`
          })

          let countryname = COUNTRIES.filter(i => i.value == this.order.business.country)[0].name
          //if(a.length)
          let wa = this.warehouse_list.filter(i => i.label.indexOf(countryname) > -1)
          if (this.no_need_warehouse_list.indexOf(+this.order.business_id) == -1) {
            if (wa.length)
              this.form.warehouse_id = wa[0].value
          }
          let glist = data.filter(i => i.field == 'product_list')[0]

          this.product_category_casader_list = glist.props.rules.filter(i => i.field == 'product_category_id_list')[0].props.options
          if (this.source_map.declare_currency) {
            if (this.form.warehouse_id) {
              let o = this.source_map.declare_currency.filter(i => i.value == this.form.warehouse_id)[0].children[0]
              this.declare_currency = o.label
              this.form.rate = o.rate
            }
            let t = this.source_map.declare_currency.filter((i) => {
              return i.children.filter(u => u.value == glist.value[0].product_currency).length > 0
            })
            if (t.length)
              this.product_rate = t[0].children[0].rate
            if (glist.value[0].product_currency == 'CNY')
              this.product_rate = 1
          }
          this.form.product_list = glist.value
          this.form.product_list.forEach((a, index) => {
            a.product_specifications = this.getSpec(this.groupOrderLine[index]) || this.formatSpec(this.groupOrderLine[index].spec)
            if (this.form.warehouse_id) {
              if (a.product_currency != this.declare_currency){
                this.$set(a, 'declare_pre_product_price', ((+a.product_price) * this.product_rate / this.form.rate).toFixed(2));
                a.declare_product_price = ((+a.product_price) * (+a.product_quantity) * this.product_rate / this.form.rate).toFixed(2)
              }
              else{
                this.$set(a, 'declare_pre_product_price', a.product_price);
                a.declare_product_price = ((+a.product_price) * (+a.product_quantity)).toFixed(2)
              }
            }
            else
              a.declare_product_price = ''
          })
          this.original_product_list = []
          this.form.product_list.forEach((g) => {
            this.original_product_list.push({ name: g.product_name, num: g.product_quantity })
          })
          this.product_currency = this.form.product_list[0].product_currency
          //this.declare_currency=this.form.product_list[0].declare_currency
          //let a=this.order.shipping_info.filter(i=>i.id=this.groupOrderLine[0].shipping_id)


          //let shipping=this.order.shipping_info.filter(i=>i.id==this.groupOrderLine[0].shipping_id)
          if (shipping.length) {
            this.form.package_tracking_number = shipping[0].AWB.replace(/:.*/, '')
            if (this.form.warehouse_id) {
              let courier_arr = this.source_map.courier.filter(i => i.value == this.form.warehouse_id)[0].children
              let co = courier_arr.filter(i => shipping[0].express.toLowerCase().indexOf(i.label.toLowerCase()) > -1)
              let other = courier_arr.filter(i => i.label.toLowerCase() == 'other')
              if (co.length)
                this.form.courier = co[0].value
              else
                this.form.courier = other[0].value
            }
          }

          this.form.declare_type = data.filter(i => i.field == 'declare_type')[0].value

          if (this.form.declare_type == 2 && data.filter(i => i.field == 'address_id')[0] && data.filter(i => i.field == 'address_id')[0].options.length) {
            let addr_zycn = this.address_list.filter((a) => {
              return a.name == this.order.id_card_info.name && a.identity_card == this.order.id_card_info.id_card
            })
            if (addr_zycn.length)
              this.form.address_id = addr_zycn[0].value
          }
          //this.form.address_id=data.filter(i=>i.field=='address_id')[0].options[0].value

          this.generateDesc()

          this.form.shipping_route = 'default'
          this.form.items_counting = 'no'
          this.form.package_content_photos = 'no'
          this.form.invoice_removal = 'no'
          break;
      }
    },
    cascaderChange(visible) {
      if (!visible){
        switch(this.express_company_code){
          case 'uszcn':
            this.generateDesc()
            break;
        }
      }
    },
    generateDesc() {
      let desc = `订单${this.baoguodanhao}`

      let arr = []
      this.form.product_list.forEach((i) => {
        let index = arr.findIndex((j) => {
          return j.product_name == i.product_name
        })
        if (index > -1)
          arr[index].product_quantity = (+arr[index].product_quantity) + (+i.product_quantity);
        else
          arr.push({ product_name: i.product_name, product_quantity: i.product_quantity })
      })
      let prod_info = arr.map((i) => {
        //let n=i.product_category_id_list.length?this.generateName(i.product_category_id_list):'品名'
        let n = i.product_name
        return `${n}${i.product_quantity}`
      })


      desc += prod_info.join('')
      if (this.form.declare_type == 1) {
        desc += '合箱发'
      }
      else {
        desc += '发'
      }
      desc += `${this.order.id_card_info.name}`
      this.form.package_description = desc
      this.$forceUpdate()
    },
    generateDescEWE() {
      let desc = `订单${this.baoguodanhao}`

      let arr = []
      this.formEWE.goodsList.forEach((i) => {
        let index = arr.findIndex((j) => {
          return j.goodsName == i.goodsName
        })
        if (index > -1)
          arr[index].quantity = (+arr[index].quantity) + (+i.quantity);
        else
          arr.push({ goodsName: i.goodsName, quantity: i.quantity })
      })
      let prod_info = arr.map((i) => {
        //let n=i.product_category_id_list.length?this.generateName(i.product_category_id_list):'品名'
        let n = i.goodsName
        return `${n}${i.quantity}`
      })


      desc += prod_info.join('')
      if (this.formEWE.type == 1) {
        desc += '合箱发'
      }
      else {
        desc += '发'
      }
      desc += `${this.order.id_card_info.name}`
      this.formEWE.nickname = desc
      this.$forceUpdate()
    },
    generateDescDF(){
      let desc = `订单${this.baoguodanhao}`

      let arr = []
      this.formDF.detailList.forEach((i) => {
        let index = arr.findIndex((j) => {
          return j.product_name == i.goodsName
        })
        if (index > -1)
          arr[index].product_quantity = (+arr[index].product_quantity) + (+i.quantity);
        else
          arr.push({ product_name: i.goodsName, product_quantity: i.quantity })
      })
      let prod_info = arr.map((i) => {
        let n = i.product_name
        return `${n}${i.product_quantity}`
      })


      desc += prod_info.join('')
      if (this.formDF.type == 1) {
        desc += '合箱发'
      }
      else {
        desc += '发'
      }
      desc += `${this.order.id_card_info.name}`
      this.formDF.parcelDescribe = desc
      this.$forceUpdate()
    },
    generateDescCPS(){
      let desc = `订单${this.baoguodanhao}`

      let arr = []
      this.formCPS.goods.forEach((i) => {
        let index = arr.findIndex((j) => {
          return j.product_name == i.title
        })
        if (index > -1)
          arr[index].product_quantity = (+arr[index].product_quantity) + (+i.qty);
        else
          arr.push({ product_name: i.title, product_quantity: i.qty })
      })
      let prod_info = arr.map((i) => {
        let n = i.product_name
        return `${n}${i.product_quantity}`
      })


      desc += prod_info.join('')
      if (this.formCPS.type == 1) {
        desc += '合箱发'
      }
      else {
        desc += '发'
      }
      desc += `${this.order.id_card_info.name}`
      this.formCPS.package_description = desc
      this.$forceUpdate()
    },
    generateDescBNS() {
      let desc = `订单${this.baoguodanhao}`

      let arr = []
      this.formBNS.product_list.forEach((i) => {
        let index = arr.findIndex((j) => {
          return j.product_name == i.product_name
        })
        if (index > -1)
          arr[index].product_quantity = (+arr[index].product_quantity) + (+i.product_quantity);
        else
          arr.push({ product_name: i.product_name, product_quantity: i.product_quantity })
      })
      let prod_info = arr.map((i) => {
        //let n=i.product_category_id_list.length?this.generateName(i.product_category_id_list):'品名'
        let n = i.product_name
        return `${n}${i.product_quantity}`
      })


      desc += prod_info.join('')
      desc += '合箱发'
      desc += `${this.order.id_card_info.name}`
      this.formBNS.package_description = desc
      this.$forceUpdate()
    },
    generateDescbeede() {
      let desc = `订单${this.baoguodanhao}`

      let arr = []
      this.formbeede.product_list.forEach((i) => {
        let index = arr.findIndex((j) => {
          return j.product_name == i.product_name
        })
        if (index > -1)
          arr[index].product_quantity = (+arr[index].product_quantity) + (+i.product_quantity);
        else
          arr.push({ product_name: i.product_name, product_quantity: i.product_quantity })
      })
      let prod_info = arr.map((i) => {
        //let n=i.product_category_id_list.length?this.generateName(i.product_category_id_list):'品名'
        let n = i.product_name
        return `${n}${i.product_quantity}`
      })


      desc += prod_info.join('')
      if (this.formbeede.shipment_method == 0) {
        desc += '合箱发'
      }
      else {
        desc += '发'
      }
      desc += `${this.order.id_card_info.name}`
      this.formbeede.package_description = desc
      this.$forceUpdate()
    },
    generateDesc1548() {
      let desc = `订单${this.form1548.ws_ordernum}`

      let arr = []
      this.form1548.goods.forEach((i) => {
        let index = arr.findIndex((j) => {
          return j.name == i.name
        })
        if (index > -1)
          arr[index].quantity = (+arr[index].quantity) + (+i.quantity);
        else
          arr.push({ name: i.name, quantity: i.quantity })
      })
      let prod_info = arr.map((i) => {
        let n = i.name
        return `${n}${i.quantity}`
      })


      desc += prod_info.join('')
      if (this.form1548.auto_apply == 0) {
        desc += '合箱发'
      }
      else {
        desc += '发'
      }
      desc += `${this.order.id_card_info.name}`
      this.form1548.mark = desc
      this.$forceUpdate()
    },
    generateDesczygjex() {
      let desc = `订单${this.baoguodanhao}`

      let arr = []
      this.formzygjex.type2.l1_product_list.forEach((i) => {
        let index = arr.findIndex((j) => {
          return j.product_name_cn == i.product_name_cn
        })
        if (index > -1)
          arr[index].product_quantity = (+arr[index].product_quantity) + (+i.product_quantity);
        else
          arr.push({ product_name_cn: i.product_name_cn, product_quantity: i.product_quantity })
      })
      let prod_info = arr.map((i) => {
        let n = i.product_name_cn
        return `${n}${i.product_quantity}`
      })


      desc += prod_info.join('')
      if (this.formzygjex.type == 'normal') {
        desc += '合箱发'
      }
      else {
        desc += '发'
      }
      desc += `${this.order.id_card_info.name}`
      this.formzygjex.type2.l1_remark = desc
      this.formzygjex.type1.product_name_01 = desc
      this.$forceUpdate()
    },
    async getInfo() {
      this.errorMessage = ''
      this.isGetFormData = true
      this.baoguodanhao = this.groupOrderLine[0].business_order_no?this.groupOrderLine[0].business_order_no:this.order.business_order_no
      let params = {}
      params.order_id = this.order.id
      params.transport_company_id = this.form.transport_company_id
      params.transport_account_id = this.form.transport_account_id
      params.package_id = this.groupOrderLine[0].shipping_id
      //测试bns
      //params.order_id=5870
      //params.package_id=this.groupOrderLine[0].shipping_id
      //params.transport_company_id=1542
      //params.tran
      //测试中环转运
      //params.transport_company_id=896
      let res = await api.getTransportFormData(this, params)
      if (res.body.result.form_data) {
        this.source_map = res.body.result.warehouse_id_sourcemap

        this.generateFormData(res.body.result.form_data)
      }
      else
        this.errorMessage = res.body.result
      this.isGetFormData = false

    },

    submit(val) {
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.option-checkbox {
  width: 30%;
}

.hearderLogo {
  position: absolute;
  width: 80%;
  top: 0;
  left: 10%;

  .header {
    padding: 50px 0;
  }
}

.trackBody {
  overflow: hidden;
  width: 1180px;
  margin: 72px auto 60px;
  background: #ffffff;
  padding: 40px 60px;
  min-height: 600px;

  .trackTitle {
    font-size: 18px;
    color: #333333;
    font-weight: 500;
    letter-spacing: 2px;
    margin-bottom: 61px;
  }
}

.getFormData {
  display: inline-block;
  width: 180px;
  margin-left: 15px;
  height: 40px;
}

.img-container {
  float: left;
  width: 120px;
  height: 120px;

  a {
    position: relative;
    overflow: hidden;
    display: block;
    width: 120px;
    height: 120px;

    .goodsNum {
      position: absolute;
      bottom: 0;
      right: 0;
      display: inline-block;
      height: 20px;
      width: 20px;
      border: 1px solid #D7D7D7;
      border-radius: 50%;
      text-align: center;
      font-size: 10px;
      line-height: 16px;
      color: #333333;
      background: #fff;
    }
  }

  img {
    height: 120px;
    width: 120px;
    object-fit: contain;
  }
}

.order-des {
  float: left;
  margin-top: -5px;
  margin-left: 20px;
  position: relative;
  min-height: 120px;

  .name a{
      font-size: 14px;
      color: rgba(51, 51, 51, 1);
      line-height: 20px;
    }

    .order-price {
      font-size: 18px;
      line-height: 32px;
      color: black;
      margin: 0;
    }

    a.order-price {
      color: #FF4650;
      font-size: 18px;
    }

    del.order-price {
      color: #B0B4BF;
      font-size: 16px;
    }
}
.declare_info_left{
    text-align:right;
    width:100px;
    margin-right:10px;
  }
@media screen and (max-width: 769px) {
  .trackBody {
    width: 100% !important;
    padding: 10px 0 !important;
    margin: 0px auto 60px;

    .trackTitle {
      padding-right: 0px !important;
      padding-bottom: 10px;
      border-bottom: 1px solid #D7D7D7;
    }
  }
}</style>



// WEBPACK FOOTER //
// src/pages/orders/list/OrderTransportApply.vue